import React, { useEffect, useState, useRef, useMemo } from 'react'
import styles from './PlanOutput.module.css'
import Logo from "../../assets/logo.png"
import Logout from '../../assets/logout.svg'
import downloadIcon from "../../assets/download-icon.png"
import DoughnutChart from '../../components/Chart/DoughnutChart'
import { prpHttpAPI } from '../../services/prpHttpAPI'
import { useNavigate, useLocation } from 'react-router-dom'
import Modal from '../../components/Modal/Modal'
import { jwtDecode } from 'jwt-decode'
const Logger = { log: console.log };

const PlanOutput = () => {
    const location = useLocation();
    const previousPage = location.state?.from || "unknown";
    const [rows, setRows] = useState([]);
    const [nonRetirementRows, setnonRetirementRows] = useState([]);
    const [userData, setUserData] = useState(null);
    const [modifiedPlanId, setmodifiedPlanId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [downloadFlag, setDownloadFlag] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [goalsData, setGoalsData] = useState({}); // New state for Goal Details
    const [unallocatedCapitalReceiptsFV, setUnallocatedCapitalReceiptsFV] = useState(0);
    const [unallocatedCapitalReceiptsRaw, setUnallocatedCapitalReceiptsRaw] = useState(0);
    const [url, setUrl] = useState(null);
    const [firstVersionDate, setFirstVersionDate] = useState(null);
    const plan_id = JSON.parse(localStorage.getItem('userData') || '{}')?.plan_id;
    const versions = localStorage.getItem('versions');
    const [totalVersions, setTotalVersions] = useState(versions);
    const versionList = Array.from({ length: totalVersions }, (_, i) => i + 1);
    const [selectedVersion, setSelectedVersion] = useState(versions);
    // Derive base plan_id (strip any existing _N suffix)
    const basePlanId = plan_id ? plan_id.split('_')[0] : '';
    const goalNetReqMapRef = React.useRef({});

    useEffect(() => {
        const val = Number(selectedVersion) || Number(totalVersions) || Number(localStorage.getItem('versions')) || 1;
        localStorage.setItem('selectedVersion', val);
        window.dispatchEvent(new Event('versionChanged'));

        return () => {
            localStorage.removeItem('selectedVersion');
            window.dispatchEvent(new Event('versionChanged'));
        };
    }, [selectedVersion, totalVersions]);

    const navigate = useNavigate()
    // token authentication 
    const checkToken = (e) => {

        const localtoken = localStorage.getItem("ssotoken");
        // const location = useLocation();
        // const queryParams = new URLSearchParams(location.search);
        // const ssotoken = queryParams.get('ssotoken');
        if (localtoken) {
            console.log('User logged in');
        }
        else {
            console.log('token not found');
            // Redirect to a different URL
            window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;

            //  navigate('');
        }
    }
    useEffect(() => {
        checkToken();
    }, [])
    // const handleLogout = () => {
    //     // Clear session storage (or localStorage if you want)
    //     localStorage.clear();
    //     navigate('/?action=logout'); // Adjust the path to your login page
    // };

    // const nonRetirementCashFlow = (userData, builtGoalsData = {}) => {

    //     let goals = userData.investmentDetails.goals;

    //     const currentAge = userData.clientsDetails.age;
    //     const retirementAge = userData.clientsDetails.year_of_retirement;
    //     const lifeExpectancy = userData.clientsDetails.life_expectancy;
    //     const yearsUnitilRetirement = userData.planDetails.YearsUnitilRetirement;

    //     // const totalInvestments = userData.planDetails.totalInvestments;
    //     const totalNonRetirementInvestment = userData.planDetails.NonRetirementInvestments;
    //     const totalNonRetirementInvestmentContribution = userData.planDetails.NonRetirementContributions;
    //     const preRetRor = userData.investmentDetails.pre_ret_ror;
    //     const postRetRor = userData.investmentDetails.post_ret_ror;
    //     // const totalContribution = userData.planDetails.TotalContributions;
    //     // var additionalSaving = userData.planDetails.shortageRYType == 'surplus' ? 0 : userData.planDetails.additionalSavRqd.monthly;
    //     // const retirementExpenseRY = userData.planDetails.retirementExpanceRY;
    //     const inflationRate = userData.clientsDetails.post_ret_inf;

    //     const annualSavings = totalNonRetirementInvestmentContribution * 12;

    //     let additionalSavings = 0;

    //     let previousYearEndValue = totalNonRetirementInvestment;
    //     let previousWithdrawal = 0;
    //     let previousAdditionalSavings = [];
    //     let newArr = [];
    //     let current_year = new Date().getFullYear();
    //     //let addinonalLumsum = [];
    //     let goalsOutput = {};


    //     let currentYearLoop = current_year;
    //     let GRetirmentYear = yearsUnitilRetirement + current_year;
    //     let age = currentAge;
    //     for (let yearsUnitRetire = 0; yearsUnitRetire <= yearsUnitilRetirement; yearsUnitRetire++) {

    //         let shortageGY = 0;
    //         let investedValue = 0;
    //         let withdrawal = 0;
    //         let additionalSavings = 0;

    //         let goalValueAtGY = 0;
    //         let currentYearWithdrawal = 0;

    //         goals.forEach((goal) => {
    //             const gYr = Number(goal.goal_year || goal.GoalYear || 0);
    //             const loanAmt = Number(goal.loan_amount || goal.LoanFunding || 0);
    //             const infl = Number(goal.expected_inflation || inflationRate || 5);
    //             const goalAmt = Number(goal.amount || goal.GoalAmtReq || 0);

    //             if (currentYearLoop == (gYr - 1) && (GRetirmentYear > gYr)) {
    //                 goalValueAtGY = Math.max(0, goalAmt - loanAmt)
    //                     * Math.pow((1 + infl / 100), (gYr - current_year));

    //                 currentYearWithdrawal += goalValueAtGY;
    //             }
    //         });
    //         withdrawal = currentYearWithdrawal;
    //         previousWithdrawal = currentYearWithdrawal;

    //         // if (currentYearLoop == goals[0].goal_year) {
    //         //     previousWithdrawal = 0;
    //         //     goalValueAtGY =
    //         //         goals[0].amount *
    //         //         Math.pow(
    //         //             (1 + inflationRate / 100),
    //         //             (goals[0].goal_year - current_year)
    //         //         );

    //         //     withdrawal = goalValueAtGY;
    //         //     previousWithdrawal = goalValueAtGY;
    //         // } else {
    //         //     withdrawal = 0;
    //         // }



    //         // Invested value
    //         investedValue = age === currentAge ? totalNonRetirementInvestment : previousYearEndValue;

    //         if (investedValue < 0) {
    //             investedValue = 0;
    //         }

    //         // Annual return
    //         let annualReturn = (investedValue * ((age == retirementAge || age > retirementAge) ? postRetRor : preRetRor)) / 100;

    //         if (annualReturn < 0) {
    //             annualReturn = 0;
    //         }

    //         // additionalSavings
    //         if (userData.planDetails.shortageRYType != 'surplus') {

    //             goals.forEach((goal, idx) => {
    //                 const gYr = Number(goal.goal_year || goal.GoalYear || 0);
    //                 const loanAmt = Number(goal.loan_amount || goal.LoanFunding || 0);
    //                 const infl = Number(goal.expected_inflation || inflationRate || 5);
    //                 const goalAmt = Number(goal.amount || goal.GoalAmtReq || 0);

    //                 if (((gYr - 1) == currentYearLoop) && (GRetirmentYear > gYr)) {
    //                     let goalValueAtGY = Math.max(0, goalAmt - loanAmt)
    //                         * Math.pow((1 + infl / 100), (gYr - current_year));

    //                     const goalKey = `${gYr}_${idx}`;
    //                     const goalData = builtGoalsData?.[goalKey];
    //                     const shortageVal = goalData ? (goalData.shortage === null || goalData.shortage === 'NaN' || isNaN(Number(goalData.shortage)) ? 0 : Number(goalData.shortage)) : null;
    //                     const isFulfilled = shortageVal !== null ? (shortageVal < 1) : false;

    //                     if (isFulfilled) {
    //                         additionalSavings = 0;
    //                         shortageGY = 0;
    //                     } else {
    //                         if (goalData) {
    //                             additionalSavings = Number(goalData.additionalSavings) || 0;
    //                             shortageGY = Number(goalData.shortage) || 0;
    //                         } else {
    //                             if (goalValueAtGY != 0) {
    //                                 shortageGY = Math.max(0, goalValueAtGY - (investedValue + annualSavings + annualReturn));
    //                             } else {
    //                                 shortageGY = 0;
    //                             }

    //                             let r = preRetRor / 100;
    //                             let n = (gYr - current_year);

    //                             additionalSavings = shortageGY > 0 && r > 0 && n > 0
    //                                 ? shortageGY / ((Math.pow(1 + r, n) - 1) / r)
    //                                 : 0;

    //                             if (goalValueAtGY < (investedValue + annualSavings + annualReturn)) {
    //                                 additionalSavings = 0;
    //                                 shortageGY = 0;
    //                             }
    //                         }
    //                     }



    //                     //previousAdditionalSavings = additionalSavings;
    //                     previousAdditionalSavings.push({ additionalSavings: additionalSavings, year: currentYearLoop });


    //                     if (currentYearLoop == '2032') {
    //                         console.log('test...');
    //                     }

    //                     const uniqueKey = `${gYr}_${idx}`;
    //                     goalsOutput[uniqueKey] = {
    //                         goals: goal,
    //                         currentYearLoop: currentYearLoop,
    //                         addinonalLumsum: shortageGY / Math.pow((1 + preRetRor / 100), (goal.goal_year - current_year)),
    //                         amountRequired: goalValueAtGY,
    //                         shortage: shortageGY,
    //                         additionalSavings: additionalSavings
    //                     }
    //                     if (shortageGY <= 0) {
    //                         goalsOutput[uniqueKey] = {
    //                             goals: goal,
    //                             currentYearLoop: currentYearLoop,
    //                             addinonalLumsum: 0,
    //                             amountRequired: goalValueAtGY,
    //                             shortage: shortageGY,
    //                             additionalSavings: additionalSavings
    //                         }
    //                     }
    //                     // console.log('additional s ', shortageGY, additionalSaving);
    //                 }
    //             });




    //             // if (goals[0].goal_year == currentYearLoop) {


    //             //     if (goalValueAtGY != 0) {
    //             //         shortageGY = goalValueAtGY - (investedValue + annualSavings + annualReturn);
    //             //         // console.log('shortageGY', currentYearLoop, shortageGY, goalValueAtGY, investedValue, annualSavings, annualReturn);
    //             //     }
    //             //     else {
    //             //         shortageGY = 0;
    //             //     }

    //             //     let r = preRetRor / 100;
    //             //     let n = (goals[0].goal_year - current_year + 1);

    //             //     additionalSavings =
    //             //         shortageGY /
    //             //         (
    //             //             (Math.pow(1 + r, n) - 1) / r
    //             //         );


    //             //     if (currentYearLoop == '2032') {
    //             //         console.log('test...');
    //             //     }
    //             // }
    //         }



    //         // Year end value
    //         const yearEndValue = (investedValue + annualReturn + annualSavings) - withdrawal;
    //         // console.log('test......', investedValue, annualReturn, annualSavings, additionalSaving, yearEndValue);




    //         // Save values
    //         newArr.push([
    //             age,
    //             currentYearLoop,
    //             investedValue,
    //             annualReturn,
    //             ((age == retirementAge || age > retirementAge) ? 0 : annualSavings),
    //             additionalSavings,
    //             withdrawal,
    //             (yearEndValue < 0 ? 0 : yearEndValue)
    //         ]);



    //         // Prepare for next loop
    //         previousWithdrawal = withdrawal;
    //         previousYearEndValue = yearEndValue;
    //         age++;
    //         currentYearLoop = currentYearLoop + 1;
    //         //rows = newArr;
    //         //setnonRetirementRows(newArr)
    //     }

    //     console.log(goalsOutput);
    //     //   let found = false;
    //     //   goals.forEach((goal) => {
    //     //         console.log(goal.goal_year);

    //     //         Object.entries(goalsOutput).forEach((gl)=>{
    //     //             if(goal.goal_year == gl[0]){
    //     //                found = true;
    //     //               // return 0;
    //     //             }
    //     //         });

    //     //       if (!found) {
    //     //           goalsOutput[goal.goal_year] = {
    //     //               goals: goal,
    //     //               currentYearLoop: 0,
    //     //               addinonalLumsum: 0,
    //     //               amountRequired: 0,
    //     //               shortage: 0,
    //     //               additionalSavings: 0
    //     //           }


    //     //       }
    //     //       found = false;
    //     //         // if(goal.year == goalsOutput){

    //     //         // }
    //     //   });


    //     // Run this after your main loop finishes
    //     goals.forEach((goal, idx) => {
    //         // Check if this specific goal instance already exists in our output
    //         const alreadyExists = Object.values(goalsOutput).some(out => out.goals === goal);

    //         if (!alreadyExists) {
    //             // Calculate the actual inflated required amount
    //             const current_year = new Date().getFullYear();
    //             const inflationRate = userData.clientsDetails.post_ret_inf ;
    //             const goalValueAtGY = (goal.amount - (Number(goal.loan_amount) || 0))
    //                 * Math.pow(
    //                     (1 + (Number(goal.expected_inflation) || inflationRate) / 100),
    //                     (goal.goal_year - current_year)
    //                 );


    //             // Add the missing goal with actual required values
    //             goalsOutput[`${goal.goal_year}_${idx}`] = {
    //                 goals: goal,
    //                 addinonalLumsum: 0,
    //                 amountRequired: goalValueAtGY,
    //                 shortage: 0,
    //                 additionalSavings: 0
    //             };
    //         }
    //     });

    //     console.log(goalsOutput);


    //     // newArr = newArr.map((row, ind) => {

    //     //     // goals.forEach((goal) => {
    //     //     //     if (row[1] == (goal.goal_year + 1)) {
    //     //     //         row[5] = 0;
    //     //     //         additionalSavings = 0;
    //     //     //         console.log('test', row[0]);
    //     //     //         // return
    //     //     //     }
    //     //     //     else {
    //     //     //         row[5] = additionalSavings;
    //     //     //     }
    //     //     // });

    //     //         //       if (row[1] == (goals[0].goal_year + 1)) {
    //     //         //     row[5] = 0;
    //     //         //     additionalSavings = 0;
    //     //         //     console.log('test', row[0]);
    //     //         //     // return
    //     //         // }
    //     //         // else {
    //     //         //     row[5] = additionalSavings;
    //     //         // }

    //     //     return row;
    //     // });

    //     // previousAdditionalSavings.forEach((val, ind) => {
    //     //     newArr = newArr.map((row, i) => {
    //     //         if (row[1] <= val.year) {
    //     //             row[5] = val.additionalSavings;
    //     //         }
    //     //         return row; // ✅ ALWAYS return
    //     //     });
    //     // });


    //     // old sort goals start


    //     // previousAdditionalSavings.sort((a, b) => a.year - b.year);

    //     // const lastGoalYear = Math.max(...previousAdditionalSavings.map(g => g.year));


    //     // Updated sort goals start
    //     let lastGoalYear;
    //     if (previousAdditionalSavings.length > 0) {
    //         previousAdditionalSavings.sort((a, b) => a.year - b.year);
    //         lastGoalYear = Math.max(...previousAdditionalSavings.map(g => g.year));
    //     }
    //     else {
    //         lastGoalYear = goals.length > 0
    //             ? Math.max(...goals.map(goal => Number(goal.goal_year)))
    //             : new Date().getFullYear();

    //         lastGoalYear = (lastGoalYear - 1);

    //         console.log("Last Goal Year:", lastGoalYear);
    //     }


    //     for (let i = 0; i < newArr.length; i++) {

    //         let row = newArr[i];

    //         let age = row[0];
    //         let year = row[1];

    //         // ✅ 1. Update Beginning Assets
    //         if (i > 0) {
    //             row[2] = newArr[i - 1][newArr[i - 1].length - 1];
    //         }

    //         let investedValue = row[2];

    //         // safety
    //         if (investedValue < 0) investedValue = 0;

    //         // ✅ 2. Recalculate Annual Return (IMPORTANT)
    //         let rate = (age >= retirementAge) ? postRetRor : preRetRor;

    //         let annualReturn = (investedValue * rate) / 100;

    //         if (annualReturn < 0) annualReturn = 0;

    //         row[3] = annualReturn;

    //         // ✅ 3. Additional Savings logic
    //         if (year > lastGoalYear) {
    //             // row[2] = 0;
    //             // row[3] = 0;
    //             row[4] = 0;
    //             row[5] = 0;


    //         } else {
    //             let totalSaving = previousAdditionalSavings.reduce((sum, goal) => {
    //                 if (year <= goal.year) {
    //                     return sum + goal.additionalSavings;
    //                 }
    //                 return sum;
    //             }, 0);

    //             row[5] = totalSaving;
    //         }

    //         let annualSavings = row[4];
    //         let additionalSavings = row[5];
    //         let withdrawal = row[6];

    //         // ✅ 4. Final Year Ending Value
    //         let yearEndValue =
    //             investedValue +
    //             annualReturn +
    //             annualSavings +
    //             additionalSavings -
    //             withdrawal;

    //         row[7] = yearEndValue < 0 ? 0 : yearEndValue;

    //         if (year >= lastGoalYear) {
    //             // row[7] = 0;
    //             newArr.splice(i + 1);
    //             break; // Stop the loop immediately
    //         }
    //     }

    //     return { goalsOutput };
    // };


    // / --- DYNAMIC LOGIC FOR FINANCIAL SUMMARY ---

    // Helper to compute total projected corpus including capital receipts
    // const computeProjectedCorpus = (goalsDataObj, planDetails, crFV) => {
    //     if (Object.keys(goalsDataObj).length > 0) {
    //         return (
    //             checkForNullOrNaN(planDetails.totalAllRetirement?.retirement)
    //             + checkForNullOrNaN(planDetails.totalAllRetirement?.retirementMonthly)
    //             + checkForNullOrNaN(planDetails.unallocatedAssetsSurplus)
    //             + checkForNullOrNaN(crFV)
    //         );
    //     } else {
    //         return (
    //             checkForNullOrNaN(planDetails.graph.investment.investmentAmount)
    //             + checkForNullOrNaN(planDetails.graph.retirementContributions.retirementContributionsAmount)
    //         );
    //     }
    // };

    // 1. Calculate Retirement Achievement % strictly based on totalAllRetirement
    const calculateAchievement = () => {
        if (!userData || !userData.planDetails) return 0;

        const safeVal = (v) => (v === null || v === 'NaN' || isNaN(v)) ? 0 : (v || 0);

        const invRY = userData.planDetails.totalAllRetirement?.retirement;
        const contribRY = userData.planDetails.totalAllRetirement?.retirementMonthly;

        const targetCorpus = userData.planDetails.retirementCorpusRY;

        const liquidSurplusVal = safeVal(userData?.planDetails?.unallocatedAssetsSurplus);
        const projectedCorpus = Object.keys(goalsData).length > 0
            ? (invRY + contribRY + liquidSurplusVal + safeVal(unallocatedCapitalReceiptsFV))
            : (invRY + contribRY);
        const achieved = (projectedCorpus / targetCorpus) * 100;

        return Math.min(Math.round(achieved), 100);
    };

    const getAllocationForGoal = (yearsAway, ror) => {
        // Long Term: More than 9 years
        if (yearsAway >= 10) {
            if (ror <= 12) return { Equity: 65, Bond: 20, Cash: 5, Gold: 7, Silver: 3, riskProfile: 'Low risk', timeHorizon: 'Long' };
            if (ror <= 16) return { Equity: 75, Bond: 10, Cash: 5, Gold: 5, Silver: 5, riskProfile: 'Moderate risk', timeHorizon: 'Long' };
            return { Equity: 85, Bond: 5, Cash: 0, Gold: 5, Silver: 5, riskProfile: 'High Risk', timeHorizon: 'Long' };
        }
        // Medium Term: 5 to 9 years
        if (yearsAway >= 5) {
            if (ror <= 10) return { Equity: 50, Bond: 30, Cash: 5, Gold: 10, Silver: 5, riskProfile: 'Low risk', timeHorizon: 'Medium' };
            if (ror <= 14) return { Equity: 65, Bond: 20, Cash: 5, Gold: 7, Silver: 3, riskProfile: 'Moderate risk', timeHorizon: 'Medium' };
            return { Equity: 75, Bond: 10, Cash: 5, Gold: 5, Silver: 5, riskProfile: 'High Risk', timeHorizon: 'Medium' };
        }
        // Short Term: 0 to 4 years
        if (ror <= 8) return { Equity: 40, Bond: 35, Cash: 10, Gold: 10, Silver: 5, riskProfile: 'Low risk', timeHorizon: 'Short' };
        if (ror <= 12) return { Equity: 50, Bond: 30, Cash: 5, Gold: 10, Silver: 5, riskProfile: 'Moderate risk', timeHorizon: 'Short' };
        return { Equity: 60, Bond: 25, Cash: 5, Gold: 7, Silver: 3, riskProfile: 'High Risk', timeHorizon: 'Short' };
    };


    const liquidSurplus = (userData?.planDetails?.unallocatedAssetsSurplus === null ||
        userData?.planDetails?.unallocatedAssetsSurplus === 'NaN' ||
        isNaN(userData?.planDetails?.unallocatedAssetsSurplus))
        ? 0
        : (userData?.planDetails?.unallocatedAssetsSurplus || 0);

    // Frontend-corrected gap and SIP — safe because userData is null-checked in render
    const safeNum = (v) => (v === null || v === undefined || v === 'NaN' || isNaN(v)) ? 0 : (Number(v) || 0);
    const hasGoalsForCorpus = Object.keys(goalsData).length > 0;
    const retInvProjected = safeNum(userData?.planDetails?.totalAllRetirement?.retirement)
        + safeNum(userData?.planDetails?.totalAllRetirement?.retirementMonthly);
    const projectedTotalCorpus = retInvProjected + safeNum(unallocatedCapitalReceiptsFV) + liquidSurplus;
    const targetCorpus = safeNum(userData?.planDetails?.retirementCorpusRY);
    const correctedGap = Math.max(0, targetCorpus - projectedTotalCorpus);
    const correctedSurplus = Math.max(0, projectedTotalCorpus - targetCorpus);
    const isCorrectedShortfall = correctedGap > 1000;
    const backendGap = safeNum(userData?.planDetails?.shortageRY);
    const backendSIPMonthly = safeNum(userData?.planDetails?.additionalSavRqd?.monthly);
    const correctedSIPMonthly = (backendGap > 0 && backendSIPMonthly > 0)
        ? Math.round(correctedGap * (backendSIPMonthly / backendGap))
        : backendSIPMonthly;
    const correctedLumpsum = (backendGap > 0 && safeNum(userData?.planDetails?.additionalLumsumRqd?.value) > 0)
        ? Math.round(correctedGap * (safeNum(userData?.planDetails?.additionalLumsumRqd?.value) / backendGap))
        : safeNum(userData?.planDetails?.additionalLumsumRqd?.value);



    const retPercent = calculateAchievement();
    const retGap = 100 - retPercent;

    // Logic Toggle: If achievement is 100, we use Scenario 2
    const equityPct = userData?.planDetails?.equityFunds?.allocation ?? 0;
    const debtPct = userData?.planDetails?.ConservativeHF?.allocation ?? 0;
    const cashPct = userData?.planDetails?.MTDebtAllocation?.allocation ?? 0;
    const goldPct = userData?.planDetails?.goldAllocation?.allocation ?? 0;
    const silverPct = userData?.planDetails?.silverAllocation?.allocation ?? 0;
    const stDebtPct = userData?.planDetails?.STDebtAllocation?.allocation ?? 0;
    const riskProfile = userData?.planDetails?.equityFunds?.riskProfile || '';
    const timeHorizon = userData?.planDetails?.equityFunds?.timeHorizon || '';
    const strategyLabel = timeHorizon && riskProfile ? `${timeHorizon} horizon — ${riskProfile}` : 'Recommended Allocation';

    // 2. Extract Goals and categorize them safely
    const allGoalsList = goalsData ? Object.values(goalsData) : [];

    const fundedGoalTypes = allGoalsList
        .filter(g => g && (g.shortage === null || isNaN(g.shortage) ? 0 : g.shortage) < 1)
        .map(g => g.goals?.goal_type?.toLowerCase() || "other goal");

    const shortGoalTypes = allGoalsList
        .filter(g => g && (g.shortage === null || isNaN(g.shortage) ? 0 : g.shortage) >= 1)
        .map(g => g.goals?.goal_type?.toLowerCase() || "other goal");

    // --- Retirement counts as its own implicit "goal" alongside the mapped life goals ---
    const isRetirementFunded = userData?.planDetails?.shortageRYType === 'surplus';
    const totalGoalsWithRetirement = allGoalsList.length + 1;
    const fundedGoalsWithRetirement = fundedGoalTypes.length + (isRetirementFunded ? 1 : 0);
    const shortGoalsWithRetirement = shortGoalTypes.length + (isRetirementFunded ? 0 : 1);

    // 3. Grammar Helper (joining array with commas and "and")
    const formatList = (arr) => {
        if (!arr || arr.length === 0) return "";

        // Remove duplicates (e.g., if there are two "child education" goals)
        const uniqueGoals = [...new Set(arr)];

        if (uniqueGoals.length === 1) return uniqueGoals[0];
        const temp = [...uniqueGoals];
        const last = temp.pop();
        return temp.join(", ") + " and " + last;
    };


    //pdfURL
    const getPdfURL = async () => {
        let returnObj = null;
        try {
            setShowModal(true);
            const result = await prpHttpAPI({ plan_id: versionedPlanId, send_notifications: true }, 'get-pdf/pdf', null, "POST", null)
            if (result.success) {
                returnObj = result;

            }
        } catch (error) {
            console.log("There is some error after api fetch", error.message);
        }

        return returnObj

    }
    //pdf download
    const donwloadPDF = async (url) => {
        //console.log('download pdf function called')
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank"
        link.download = `${plan_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        //console.log("pdfUrl", url);

    }

    // Construct version-aware plan_id for API calls
    const versionedPlanId = selectedVersion <= 1 ? basePlanId : `${basePlanId}_${selectedVersion}`;

    const handleVersionChange = (e) => {
        const val = Number(e.target.value);
        setSelectedVersion(val);
        localStorage.setItem('selectedVersion', val);
        window.dispatchEvent(new Event('versionChanged'));
    };

    useEffect(() => {
        if (!basePlanId) return;
        const getPdfDetails = async () => {
            try {
                setLoading(true);
                const versionData = {
                    plan_id: versionedPlanId,
                    send_notifications: previousPage === "search" ? false : true
                };
                const result = await prpHttpAPI(versionData, 'get-pdf/details', null, "POST", null);

                if (result?.success) {
                    const prevUserData = localStorage.getItem('userData');
                    const prevUser = prevUserData ? JSON.parse(prevUserData) : {};
                    const prevInvData = localStorage.getItem('clientInvestmentData');
                    const prevInv = prevInvData ? JSON.parse(prevInvData) : {};

                    // When switching versions we must trust the API fully —
                    // don't let stale localStorage data override a different version's values.
                    // Only merge localStorage on the very first load (initial version).
                    const isVersionSwitch = versionedPlanId !== (prevUser.plan_id || '');

                    const cleanClientData = isVersionSwitch
                        ? {
                            // For a version switch: use API data entirely; keep only non-plan identity fields
                            ...result.clientsDetails,
                            client_name: result.clientsDetails?.client_name || prevUser.client_name || "",
                            pan_number: result.clientsDetails?.pan_number || prevUser.pan_number || "",
                            spoc_rm: result.clientsDetails?.spoc_rm || result.clientsDetails?.rm_code || prevUser.spoc_rm || "",
                            client_email: result.clientsDetails?.client_email || result.clientsDetails?.email_id || prevUser.client_email || "",
                            email_id: result.clientsDetails?.email_id || result.clientsDetails?.client_email || prevUser.email_id || "",
                            plan_id: versionedPlanId,
                        }
                        : {
                            // Initial load: prefer prevUser for non-clinical identity fields
                            ...prevUser,
                            ...result.clientsDetails,
                            client_name: prevUser.client_name ?? result.clientsDetails?.client_name ?? "",
                            pan_number: prevUser.pan_number ?? result.clientsDetails?.pan_number ?? "",
                            spoc_rm: prevUser.spoc_rm ?? result.clientsDetails?.spoc_rm ?? result.clientsDetails?.rm_code ?? "",
                            assign_plan: prevUser.assign_plan ?? result.clientsDetails?.assign_plan ?? "",
                            client_email: prevUser.client_email ?? prevUser.email_id ?? result.clientsDetails?.client_email ?? result.clientsDetails?.email_id ?? "",
                            email_id: prevUser.client_email ?? prevUser.email_id ?? result.clientsDetails?.client_email ?? result.clientsDetails?.email_id ?? "",
                            plan_id: prevUser.plan_id ?? result.clientsDetails?.plan_id ?? "",
                            family_members: (prevUser.family_members?.length > 0)
                                ? prevUser.family_members
                                : (result.clientsDetails?.family_members ?? []),
                            // Clinical fields MUST come from the API — never inherit from stale prevUser
                            age: result.clientsDetails?.age ?? prevUser.age,
                            year_of_retirement: result.clientsDetails?.year_of_retirement ?? prevUser.year_of_retirement,
                            post_ret_inf: result.clientsDetails?.post_ret_inf ?? prevUser.post_ret_inf,
                            life_expectancy: result.clientsDetails?.life_expectancy ?? prevUser.life_expectancy,
                            monthly_expenses: result.clientsDetails?.monthly_expenses ?? prevUser.monthly_expenses,
                            annual_income: result.clientsDetails?.annual_income ?? prevUser.annual_income,
                            annual_growth_rate: result.clientsDetails?.annual_growth_rate ?? prevUser.annual_growth_rate,
                        };
                    localStorage.setItem('userData', JSON.stringify(cleanClientData));
                    localStorage.setItem('planDetails', JSON.stringify(result.planDetails));

                    // For a version switch: use API investment data directly (no stale merge)
                    const mergedInvestment = isVersionSwitch
                        ? result.investmentDetails
                        : {
                            ...result.investmentDetails,
                            ...prevInv,
                            goals: Array.isArray(result.investmentDetails?.goals) ? result.investmentDetails.goals : (prevInv.goals || []),
                            capital_receipts: (prevInv.capital_receipts?.length > 0)
                                ? prevInv.capital_receipts
                                : (result.investmentDetails?.capital_receipts || []),
                            insurance_coverage: (prevInv.insurance_coverage?.length > 0)
                                ? prevInv.insurance_coverage
                                : (result.investmentDetails?.insurance_coverage || []),
                            liabilities_loans: (prevInv.liabilities_loans?.length > 0)
                                ? prevInv.liabilities_loans
                                : (result.investmentDetails?.liabilities_loans || []),
                            extra_retirement: (prevInv.extra_retirement && (Array.isArray(prevInv.extra_retirement) ? prevInv.extra_retirement.length > 0 : true))
                                ? prevInv.extra_retirement
                                : (result.investmentDetails?.extra_retirement || []),
                            extra_liquid: (prevInv.extra_liquid && (Array.isArray(prevInv.extra_liquid) ? prevInv.extra_liquid.length > 0 : true))
                                ? prevInv.extra_liquid
                                : (result.investmentDetails?.extra_liquid || []),
                        };
                    localStorage.setItem('clientInvestmentData', JSON.stringify(mergedInvestment));

                    const mergedResult = { ...result, clientsDetails: cleanClientData, investmentDetails: mergedInvestment };
                    setUserData(mergedResult);
                    const _fvPlanId = result.clientsDetails?.plan_id || '';
                    const _fvBaseId = _fvPlanId.split('_')[0];
                    if (_fvPlanId.includes('_') && _fvBaseId) {
                        prpHttpAPI({ plan_id: _fvBaseId, send_notifications: false }, 'get-pdf/details', null, 'POST', null)
                            .then(v1 => { if (v1?.success) setFirstVersionDate(v1.clientsDetails?.created_at); })
                            .catch(() => { });
                    } else {
                        setFirstVersionDate(result.clientsDetails?.created_at);
                    }

                    // Reset goals/cashflow state before populating with new version's data
                    setGoalsData({});
                    setRows([]);
                    setnonRetirementRows([]);
                    setUnallocatedCapitalReceiptsFV(0);
                    setUnallocatedCapitalReceiptsRaw(0);

                    let planId = result.clientsDetails?.plan_id || "";
                    planId = planId.split('_')[0];
                    setmodifiedPlanId(planId);

                    // If versions not in localStorage (e.g. user navigated from Plan PDF button),
                    // fetch the version count from the search-plan API so the dropdown shows correctly.
                    if (!localStorage.getItem('versions') && planId) {
                        try {
                            const localtoken = localStorage.getItem("ssotoken");
                            const versionResult = await prpHttpAPI({ plan_id: planId }, 'search-plan', localtoken, "POST", null);
                            if (versionResult?.success) {
                                const fetchedVersions = versionResult.data?.version?.versions || 1;
                                localStorage.setItem('versions', fetchedVersions);
                                setTotalVersions(fetchedVersions);
                                // Keep selectedVersion pointed at the current version if possible
                                const currentVersionNum = versionedPlanId.includes('_')
                                    ? Number(versionedPlanId.split('_').pop()) || fetchedVersions
                                    : fetchedVersions;
                                setSelectedVersion(currentVersionNum);
                            }
                        } catch (vErr) {
                            console.warn("Could not fetch version count:", vErr.message);
                        }
                    }

                    // --- STEP 1: Goals output — cascade logic (matches GoalDetail.jsx exactly) ---
                    const d = mergedResult.investmentDetails;
                    const currentYearCascade = new Date().getFullYear();
                    const otherLabel = d.other_non_retirement_label || 'Other Liquid';

                    // Compute WPreRoR
                    const retPctMap = {};
                    (d.return_percent || []).forEach(r => { retPctMap[r.asset] = Number(r.return_percent) || 0; });
                    const defRet = { mf: 12, stocks: 12, bonds: 8, fdrd: 7, other_liquid: 10 };
                    const liqHoldings = {
                        mf: Number(d.mf_holding) || 0,
                        stocks: Number(d.stocks_holding) || 0,
                        bonds: Number(d.bonds_holding) || 0,
                        fdrd: Number(d.fdrd_holding) || 0,
                        other_liquid: Number(d.other_non_retirement_investment_holding) || 0,
                    };
                    let totalLiqSum = Object.values(liqHoldings).reduce((s, v) => s + v, 0);
                    let wSum = Object.entries(liqHoldings).reduce((s, [a, h]) =>
                        s + h * (retPctMap[a] !== undefined ? retPctMap[a] : (defRet[a] || 0)), 0);

                    if (Array.isArray(d.extra_liquid)) {
                        d.extra_liquid.forEach((item) => {
                            const h = Number(item.numericHolding || item.amount || item.holding || item.value || 0);
                            const ror = Number(item.returnRate || item.return_percent || item.rate || 0);
                            if (h > 0) {
                                totalLiqSum += h;
                                wSum += h * ror;
                            }
                        });
                    }

                    let WPreRoR = 0.10;
                    if (d.liquid_weighted_return !== undefined && d.liquid_weighted_return !== null && !isNaN(Number(d.liquid_weighted_return))) {
                        WPreRoR = Number(d.liquid_weighted_return) / 100;
                    } else if (totalLiqSum > 0) {
                        WPreRoR = wSum / totalLiqSum / 100;
                    } else if (d.pre_ret_ror) {
                        WPreRoR = Number(d.pre_ret_ror) / 100;
                    }
                    const CRExpReturn = d.cr_exp_return ? Number(d.cr_exp_return) / 100 : 0.06;
                    const capitalReceiptsCascade = d.capital_receipts || [];

                    // Investment pools
                    const remainingHoldingsPool = {
                        'Mutual Funds': Number(d.mf_holding) || 0,
                        'Stocks': Number(d.stocks_holding) || 0,
                        'Bonds': Number(d.bonds_holding) || 0,
                        'FD/RD': Number(d.fdrd_holding) || 0,
                        [otherLabel]: Number(d.other_non_retirement_investment_holding) || 0,
                    };
                    const remainingSIPsPool = {
                        'Mutual Funds': Number(d.mf_monthly) || 0,
                        'Stocks': Number(d.stocks_monthly) || 0,
                        'Bonds': Number(d.bonds_monthly) || 0,
                        'FD/RD': Number(d.fdrd_monthly) || 0,
                        [otherLabel]: Number(d.other_non_retirement_investment_monthly) || 0,
                    };

                    if (Array.isArray(d.extra_liquid)) {
                        d.extra_liquid.forEach((item, idx) => {
                            const label = item.label?.trim() || `Other Non Ret. ${idx + 1}`;
                            if (label) {
                                const h = item.numericHolding != null ? Number(item.numericHolding)
                                    : Number(String(item.holding || item.amount || 0).replace(/,/g, '')) || 0;
                                const s = item.numericMonthly != null ? Number(item.numericMonthly)
                                    : Number(String(item.monthly || item.sip_amount || 0).replace(/,/g, '')) || 0;
                                remainingHoldingsPool[label] = (remainingHoldingsPool[label] || 0) + h;
                                remainingSIPsPool[label] = (remainingSIPsPool[label] || 0) + s;
                            }
                        });
                    }

                    const crRemainingCascade = capitalReceiptsCascade.map(r =>
                        Number(String(r.amount || r.CRAmt || 0).replace(/,/g, ''))
                    );

                    let carriedSurplusCR = 0;
                    let carriedSurplusInv = 0;
                    let lastGoalYearCascade = 0;
                    let carriedSips = [];

                    // Sort + pre-compute FVs
                    const enrichedGoals = [...(d.goals || [])]
                        .map((g, idx) => {
                            const GoalYear = Number(g.goal_year) || 0;
                            const GoalAmtReq = Number(g.amount || 0);
                            const LoanFunding = Number(g.loan_amount || 0);
                            const n = Math.max(0, GoalYear - currentYearCascade);
                            const inf = Number(g.expected_inflation || 5) / 100;
                            const GoalRequiredValue = Math.max(0, GoalAmtReq - LoanFunding) * Math.pow(1 + inf, n);
                            return { g, idx, GoalYear, GoalRequiredValue, n };
                        })
                        .sort((a, b) => a.GoalYear - b.GoalYear || (b.idx - a.idx))
                        .map(item => {
                            const { g, n } = item;
                            let goalHoldingSum = 0;
                            let goalSipSum = 0;

                            const allocatedInvestments = (g.additional_investment || []).map(row => {
                                if (!row.name) return { ...row, actualHolding: 0, actualSip: 0 };
                                const rawH = Number(row.amount || row.CurrentAvailable || 0);
                                const rawS = Number(row.sip_amount || row.SIPAmt || 0);
                                const aH = Math.min(rawH, remainingHoldingsPool[row.name] || 0);
                                const aS = Math.min(rawS, remainingSIPsPool[row.name] || 0);
                                remainingHoldingsPool[row.name] = Math.max(0, (remainingHoldingsPool[row.name] || 0) - aH);
                                remainingSIPsPool[row.name] = Math.max(0, (remainingSIPsPool[row.name] || 0) - aS);
                                goalHoldingSum += aH;
                                goalSipSum += aS;
                                return { ...row, actualHolding: aH, actualSip: aS };
                            });

                            const InvestmentTaggedFV = goalHoldingSum * Math.pow(1 + WPreRoR, n);
                            const AI = Number(g.stepup_sip || g.step_up || 0) / 100;
                            let MonthlyInvestmentFV = 0;
                            if (n > 0 && goalSipSum > 0) {
                                if (Math.abs(WPreRoR - AI) < 0.000001) {
                                    MonthlyInvestmentFV = goalSipSum * 12 * n * Math.pow(1 + WPreRoR, n - 1);
                                } else {
                                    MonthlyInvestmentFV = goalSipSum * 12 *
                                        (Math.pow(1 + WPreRoR, n) - Math.pow(1 + AI, n)) / (WPreRoR - AI);
                                }
                            }
                            return { ...item, InvestmentTaggedFV, MonthlyInvestmentFV, allocatedInvestments };
                        });

                    // Cascade loop
                    const builtGoalsData = {};

                    for (const item of enrichedGoals) {
                        const { g, GoalYear, GoalRequiredValue, InvestmentTaggedFV, n } = item;
                        const futureCapitalReceipts = capitalReceiptsCascade
                            .filter(cr => Number(cr.year || cr.CRYear || 0) > GoalYear)
                            .reduce((sum, cr) => {
                                return sum + Number(cr.amount || cr.CRAmt || 0);
                            }, 0);

                        let CapReceiptsAtGoalYear = 0;
                        let remainingToSettle = GoalRequiredValue;

                        // Gross carried surplus available AT this goal year — captured BEFORE
                        // steps 1 & 2 decrement carriedSurplusCR / carriedSurplusInv.
                        let carriedSurplusAvailableAtGoalYear = 0;
                        if (carriedSurplusCR > 0 && lastGoalYearCascade > 0 && GoalYear >= lastGoalYearCascade) {
                            carriedSurplusAvailableAtGoalYear +=
                                carriedSurplusCR * Math.pow(1 + CRExpReturn, GoalYear - lastGoalYearCascade);
                        }
                        if (carriedSurplusInv > 0 && lastGoalYearCascade > 0 && GoalYear >= lastGoalYearCascade) {
                            carriedSurplusAvailableAtGoalYear +=
                                carriedSurplusInv * Math.pow(1 + WPreRoR, GoalYear - lastGoalYearCascade);
                        }

                        // 1. Carry CR surplus
                        if (carriedSurplusCR > 0 && lastGoalYearCascade > 0 && GoalYear >= lastGoalYearCascade && remainingToSettle > 0) {
                            const yrs = GoalYear - lastGoalYearCascade;
                            const compounded = carriedSurplusCR * Math.pow(1 + CRExpReturn, yrs);
                            const apply = Math.min(compounded, remainingToSettle);
                            CapReceiptsAtGoalYear += apply;
                            remainingToSettle -= apply;
                            carriedSurplusCR -= apply / Math.pow(1 + CRExpReturn, yrs);
                        }

                        // 2. Carry investment surplus
                        let cascadedLiquidSurplusAtStart = 0;
                        let cascadedLiquidSurplusUsed = 0;
                        if (carriedSurplusInv > 0 && lastGoalYearCascade > 0 && GoalYear >= lastGoalYearCascade) {
                            const yrs = GoalYear - lastGoalYearCascade;
                            cascadedLiquidSurplusAtStart = carriedSurplusInv * Math.pow(1 + WPreRoR, yrs);
                        }

                        if (carriedSurplusInv > 0 && lastGoalYearCascade > 0 && GoalYear >= lastGoalYearCascade && remainingToSettle > 0) {
                            const yrs = GoalYear - lastGoalYearCascade;
                            const compounded = carriedSurplusInv * Math.pow(1 + WPreRoR, yrs);
                            const apply = Math.min(compounded, remainingToSettle);
                            CapReceiptsAtGoalYear += apply;
                            remainingToSettle -= apply;
                            carriedSurplusInv -= apply / Math.pow(1 + WPreRoR, yrs);
                            cascadedLiquidSurplusUsed = apply;
                        }

                        // Snapshot CR remaining BEFORE this goal consumes any CRs (used for display)
                        const crSnapshotBeforeGoal = [...crRemainingCascade];

                        // Total Capital Receipts and carried surplus available at this GoalYear before consumption
                        let totalCRAndSurplusAvailable = carriedSurplusAvailableAtGoalYear;

                        for (let i = 0; i < capitalReceiptsCascade.length; i++) {
                            if ((crRemainingCascade[i] || 0) <= 0.01) continue;
                            const cr = capitalReceiptsCascade[i];
                            const CRYear = Number(cr.year || cr.CRYear || 0);
                            if (GoalYear >= CRYear) {
                                const yrs = Math.max(0, GoalYear - CRYear);
                                const growthFactor = Math.pow(1 + CRExpReturn, yrs);
                                totalCRAndSurplusAvailable += crRemainingCascade[i] * growthFactor;
                            }
                        }

                        // 3. Capital receipts on remaining gap only
                        for (let i = 0; i < capitalReceiptsCascade.length; i++) {
                            if (remainingToSettle <= 0.01) break;
                            if ((crRemainingCascade[i] || 0) <= 0.01) continue;
                            const cr = capitalReceiptsCascade[i];
                            const CRYear = Number(cr.year || cr.CRYear || 0);

                            if (GoalYear >= CRYear) {
                                const yrs = Math.max(0, GoalYear - CRYear);
                                const growthFactor = Math.pow(1 + CRExpReturn, yrs);
                                const maxFV = crRemainingCascade[i] * growthFactor;
                                const crFV = Math.min(maxFV, remainingToSettle);
                                CapReceiptsAtGoalYear += crFV;
                                remainingToSettle -= crFV;
                                crRemainingCascade[i] -= crFV / growthFactor;
                            }
                        }

                        // 4. Carried SIPs

                        let cascadedSipFV = 0;
                        if (carriedSips.length > 0 && GoalYear > 0) {
                            let prevSipFV = 0;
                            carriedSips.forEach(sip => {
                                if (GoalYear <= sip.PreviousGoalYear) return;
                                const yearsGap = GoalYear - sip.PreviousGoalYear;
                                const yearsToPrev = sip.PreviousGoalYear - currentYearCascade;
                                const sipStart = sip.SIPAmt * Math.pow(1 + sip.AI, yearsToPrev);
                                if (Math.abs(WPreRoR - sip.AI) < 0.000001) {
                                    prevSipFV += sipStart * 12 * ((Math.pow(1 + WPreRoR, yearsGap) - 1) / WPreRoR);
                                } else {
                                    prevSipFV += sipStart * 12 *
                                        (Math.pow(1 + WPreRoR, yearsGap) - Math.pow(1 + sip.AI, yearsGap)) /
                                        (WPreRoR - sip.AI);
                                }
                                sip.PreviousGoalYear = GoalYear;
                            });
                            CapReceiptsAtGoalYear += prevSipFV;
                            remainingToSettle = Math.max(0, remainingToSettle - prevSipFV);
                            cascadedSipFV = prevSipFV;
                        }

                        // Freed SIP from earlier funded goals cascades forward — surface it
                        // in the displayed CR / Carried Surplus (FV) for this goal
                        totalCRAndSurplusAvailable += cascadedSipFV;

                        // 5. Then deduct tagged holding FV (only what's needed)
                        const holdingFVUsed = Math.min(InvestmentTaggedFV, remainingToSettle);
                        remainingToSettle = Math.max(0, remainingToSettle - InvestmentTaggedFV);

                        // 6. Then deduct tagged SIP FV (only what's needed)
                        const sipFVUsed = Math.min(item.MonthlyInvestmentFV, remainingToSettle);
                        remainingToSettle = Math.max(0, remainingToSettle - item.MonthlyInvestmentFV);

                        // 7. Totals
                        const TotalAvailable = holdingFVUsed + sipFVUsed + CapReceiptsAtGoalYear;
                        const GoalNetReq = Math.max(0, GoalRequiredValue - TotalAvailable);
                        const newSurplus = Math.max(0, TotalAvailable - GoalRequiredValue);

                        // 8. Update surplus pools
                        if (GoalNetReq > 0) {
                            carriedSurplusCR = 0;
                            carriedSurplusInv = 0;
                        } else {
                            if (carriedSurplusInv > 0 && lastGoalYearCascade > 0 && GoalYear > lastGoalYearCascade) {
                                carriedSurplusInv *= Math.pow(1 + WPreRoR, GoalYear - lastGoalYearCascade);
                            }
                            carriedSurplusInv += newSurplus;
                        }

                        // 9. Register freed SIPs
                        const currentAI = Number(g.stepup_sip || g.step_up || g.GrowthRate || 0) / 100;
                        (item.allocatedInvestments || []).forEach(row => {
                            if ((row.actualSip || 0) > 0) {
                                carriedSips.push({ SIPAmt: row.actualSip, AI: currentAI, PreviousGoalYear: GoalYear });
                            }
                        });

                        if (GoalYear > lastGoalYearCascade) {
                            lastGoalYearCascade = GoalYear;
                        }

                        // 10. Indicative SIP & lumpsum
                        let indicativeSip = 0;
                        let indicativeSipAnnual = 0;
                        let goalStepUpRateUsed = 0;
                        if (n > 0 && GoalNetReq > 0) {
                            const r = WPreRoR;
                            const rawStepUp = g.stepup_sip || g.step_up || g.GrowthRate || 0;
                            const stepupVal = (isNaN(Number(String(rawStepUp).replace(/[^0-9.-]/g, '')))
                                ? 0
                                : Number(String(rawStepUp).replace(/[^0-9.-]/g, ''))) / 100;
                            goalStepUpRateUsed = stepupVal;

                            // Matches GoalDetail.jsx exactly. denom carries the ×12, so
                            // GoalNetReq/denom is the MONTHLY SIP — do not divide again.
                            const denom = (Math.abs(r - stepupVal) < 0.000001)
                                ? 12 * n * Math.pow(1 + r, n - 1)
                                : 12 * (Math.pow(1 + r, n) - Math.pow(1 + stepupVal, n)) / (r - stepupVal);
                            indicativeSip = denom > 0 ? GoalNetReq / denom : 0;
                            indicativeSipAnnual = indicativeSip * 12;
                        }
                        const indicativeLumpsum = n > 0
                            ? Math.max(0, GoalNetReq / Math.pow(1 + WPreRoR, n))
                            : 0;
                        const key = `${g.goal_year || g.GoalYear || GoalYear}_${item.idx}`;

                        builtGoalsData[key] = {
                            goals: g,
                            amountRequired: GoalRequiredValue,
                            taggedInvestmentsFV: holdingFVUsed,
                            monthlyInvestmentFV: sipFVUsed,
                            capitalReceiptFV: totalCRAndSurplusAvailable > 0 ? totalCRAndSurplusAvailable : CapReceiptsAtGoalYear,
                            futureCapitalReceipts: futureCapitalReceipts,
                            totalProjected: holdingFVUsed + sipFVUsed + CapReceiptsAtGoalYear,
                            shortage: GoalNetReq,
                            additionalSavings: indicativeSip,
                            additionalSavingsAnnual: indicativeSipAnnual,
                            stepUpRateUsed: goalStepUpRateUsed,
                            addinonalLumsum: indicativeLumpsum,
                            crRemainingSnapshot: crSnapshotBeforeGoal,
                            cascadedLiquidSurplus: cascadedLiquidSurplusAtStart,
                            cascadedLiquidSurplusUsed: cascadedLiquidSurplusUsed,
                            cascadedSurplusFV: carriedSurplusAvailableAtGoalYear + cascadedSipFV
                        };
                    }

                    const retirementYear = new Date().getFullYear() - (mergedResult.clientsDetails.age || 0) + (mergedResult.clientsDetails.year_of_retirement || 0);
                    let unallocatedCRRaw = crRemainingCascade.reduce((sum, amt) => sum + (Number(amt) || 0), 0);

                    // CR surplus = col[7] (Net Capital Receipts) from the goal cashflow table
                    // at the year BEFORE retirement — this is the running compounded CR value
                    // at that point, which correctly reflects CRs net of all goal consumption
                    // We set this AFTER reading rawNonRet below (STEP 2)
                    let unallocatedCRFV = 0;

                    setGoalsData(builtGoalsData);

                    goalNetReqMapRef.current = Object.fromEntries(
                        Object.entries(builtGoalsData).map(([k, v]) => [k, v.shortage])
                    );


                    // --- STEP 2: Non-retirement cashflow rows ---
                    // Use API data only (planDetails is the single source of truth)
                    const apiCF = mergedResult.planDetails?.cashflow;
                    const rawNonRet = Array.isArray(apiCF) ? apiCF : null;
                    if (Array.isArray(rawNonRet) && rawNonRet.length > 2) {
                        const yearBeforeRetirement = retirementYear - 1;
                        const cfDataRows = rawNonRet.slice(2); // skip 2 header rows
                        const rowBeforeRetirement = cfDataRows.find(r => Number(r[1]) === yearBeforeRetirement);
                        if (rowBeforeRetirement) {
                            unallocatedCRFV = Number(rowBeforeRetirement[7]) || 0;
                        } else {
                            const lastRow = cfDataRows[cfDataRows.length - 1];
                            unallocatedCRFV = lastRow ? (Number(lastRow[7]) || 0) : 0;
                        }

                        // Trust the backend r[5] value directly for Additional Savings.
                        const finalRows = rawNonRet.slice(2).map(r => {
                            return [
                                r[0] ?? 0,                          // Age
                                r[1] ?? 0,                          // Year
                                r[2] ?? 0,                          // Opening Balance
                                r[3] ?? 0,                          // Returns
                                r[4] ?? 0,                          // Current Savings
                                r[5] ?? 0,                          // Additional Savings — annual, step-up compounded
                                Math.abs(r[6] ?? 0),                // Goal Withdrawal (positive)
                                r[7] ?? 0,                          // Net Capital Receipts  (col 7)
                                r[8] ?? 0,                          // Net Goal Requirement  (col 8)
                                r[9] ?? 0                           // Year End Value        (col 9)
                            ];
                        });
                        setnonRetirementRows(finalRows);
                    }

                    const crSurplusFV = Math.max(0, unallocatedCRFV);
                    setUnallocatedCapitalReceiptsFV(crSurplusFV);
                    setUnallocatedCapitalReceiptsRaw(crSurplusFV);

                    // --- STEP 3: Retirement cashflow rows ---
                    const apiRet = mergedResult.planDetails?.retirementCashflow;
                    const rawRet = Array.isArray(apiRet) ? apiRet : null;
                    if (Array.isArray(rawRet) && rawRet.length > 1) {
                        const newArr = rawRet.slice(1).map(r => [
                            `${r[0]} / ${r[1]}`,  // Age / Year
                            r[2] ?? 0,             // Beginning Assets
                            r[3] ?? 0,             // Annual Return
                            r[4] ?? 0,             // Annual Savings
                            r[5] ?? 0,             // Additional Savings
                            r[6] ?? 0,             // Capital Receipts      (col 6)
                            r[7] ?? 0,             // Expense Withdrawal    (col 7)
                            r[8] ?? 0,             // Goal Withdrawal       (col 8)
                            r[9] ?? 0              // Year End Value        (col 9)
                        ]);
                        console.log("SETTING ROWS - index 19:", newArr[19]);
                        setRows(newArr);
                    }
                }
            } catch (error) {
                console.log("There is some error after api fetch", error.message);
            } finally {
                setLoading(false);
            }
        };
        getPdfDetails();
    }, [selectedVersion, basePlanId])
    //version select
    // Handle selection change
    // const handleSelectChange = (event) => {
    //     const selectedValue = event.target.value;
    //     let updatedPlanId = "";
    //     if (selectedValue == 1) {
    //         updatedPlanId = modifiedPlanId
    //     } else {
    //         updatedPlanId = `${modifiedPlanId}_${selectedValue}`;
    //     }

    //     setSelectedVersion(selectedValue);
    //     localStorage.removeItem("plan_id");
    // };
    //  date fomatting 
    const formatDate = (dateString) => {
        if (!dateString) return '—';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '—';
        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC'
        }).format(date);
    }
    // nullOrNaN check
    const checkForNullOrNaN = (value) => {
        return (value === null || value === 'NaN' || isNaN(value)) ? 0 : value;
    }
    // make values to crores and lakh 

    function formatNumberToIndianUnits(num) {
        let flag = false;
        if (num < 0) flag = true;
        num = Math.abs(num)
        if (num >= 1e7) {
            return (flag ? -(num / 1e7).toFixed(2) + " Cr" : (num / 1e7).toFixed(2) + " Cr");
        }
        else if (num >= 1e5) {
            return (flag ? -(num / 1e5).toFixed(2) + " Lakh" : (num / 1e5).toFixed(2) + " Lakh");
        }
        else {
            return (flag ? -Intl.NumberFormat('en-IN').format(num.toFixed(2)) : Intl.NumberFormat('en-IN').format(num.toFixed(2)));
        }
    }

    // Formatter for Insurance values (e.g. 1.5 Cr, 10 L, 50,000)
    function formatInsuranceValue(num) {
        if (!num || isNaN(num)) return "0";
        if (num >= 10000000) { // 1 Crore = 100 Lakhs
            const crores = num / 10000000;
            return (crores % 1 === 0 ? crores.toFixed(0) : crores.toFixed(2)) + " Cr";
        }
        if (num >= 100000) {
            const lakhs = num / 100000;
            return (lakhs % 1 === 0 ? lakhs.toFixed(0) : lakhs.toFixed(1)) + " L";
        }
        return Intl.NumberFormat('en-IN').format(Math.round(num));
    }

    // Term Insurance — one row per term policy.
    // Required comes from backend planDetails.insurance.termPolicies (same order as Term policies in insurance_coverage).
    function getTermInsuranceRows() {
        const policies = userData?.investmentDetails?.insurance_coverage || [];
        const recommendedTerm = checkForNullOrNaN(userData?.planDetails?.insurance?.li_si);
        const backendTermRows = userData?.planDetails?.insurance?.termPolicies || [];
        const termPoliciesList = policies.filter(p => p.type === 'Term Insurance');
        if (termPoliciesList.length === 0) {
               return [{ key: 0, label: 'Term Insurance', isHLV: true, required: recommendedTerm, existing: 0, gap: recommendedTerm }];
        }
        return termPoliciesList.map((p, i) => {
            const b = backendTermRows[i];
            const required = checkForNullOrNaN(b?.required ?? (i === 0 ? recommendedTerm : 0));
            const existing = checkForNullOrNaN(p.coverage);
            return {
                key: i,
                label: 'Term Insurance',
                isHLV: (b?.method || p.calcMethod) === 'HLV',
                required,
                existing,
                gap: Math.max(0, required - existing),
            };
        });
    }

    // function formatSipToK(num) {
    //     const safeNum = checkForNullOrNaN(num);
    //     if (safeNum <= 0) return "0K";
    //     return `${Math.round(safeNum / 1000)}K`;
    // }

    const getRetirementRate = (index, defaultRate) => {
        let retArr = userData?.investmentDetails?.retirement_returns;
        if (typeof retArr === 'string') {
            try { retArr = JSON.parse(retArr); } catch (e) { }
        }
        if (Array.isArray(retArr) && retArr[index] !== undefined && retArr[index] !== null && retArr[index] !== '') {
            return `${retArr[index]}%`;
        }
        let rp = userData?.investmentDetails?.return_percent;
        if (typeof rp === 'string') {
            try { rp = JSON.parse(rp); } catch (e) { }
        }
        if (Array.isArray(rp)) {
            const assetKeys = ["epf", "ppf", "vpf", "nps", "other_retirement"];
            const found = rp.find(r => r.asset === assetKeys[index]);
            if (found && found.return_percent !== undefined && found.return_percent !== null) {
                return `${found.return_percent}%`;
            }
        }
        return defaultRate;
    };

    const getLiquidRate = (index, defaultRate) => {
        let liqArr = userData?.investmentDetails?.liquid_returns;
        if (typeof liqArr === 'string') {
            try { liqArr = JSON.parse(liqArr); } catch (e) { }
        }
        if (Array.isArray(liqArr) && liqArr[index] !== undefined && liqArr[index] !== null && liqArr[index] !== '') {
            return `${liqArr[index]}%`;
        }
        let rp = userData?.investmentDetails?.return_percent;
        if (typeof rp === 'string') {
            try { rp = JSON.parse(rp); } catch (e) { }
        }
        if (Array.isArray(rp)) {
            const assetKeys = ["mf", "stocks", "bonds", "fdrd", "other_liquid"];
            const found = rp.find(r => r.asset === assetKeys[index]);
            if (found && found.return_percent !== undefined && found.return_percent !== null) {
                return `${found.return_percent}%`;
            }
        }
        return defaultRate;
    };

    const getRateClass = (rateStr) => {
        const numericRate = parseFloat(rateStr);
        if (isNaN(numericRate)) return styles.rateGrey;
        if (numericRate >= 8) return styles.rateBlue;
        if (numericRate <= 7) return styles.rateRed;
        return styles.rateGrey;
    };

    const getCalculatedWeightedReturns = () => {
        const inv = userData?.investmentDetails || {};

        const parseNum = (val) => {
            if (val === null || val === undefined) return 0;
            const cleaned = String(val).replace(/,/g, '').trim();
            const n = parseFloat(cleaned);
            return isNaN(n) ? 0 : n;
        };

        const parseRate = (val, defaultRate) => {
            if (val === undefined || val === null || val === '') return parseFloat(defaultRate);
            const cleaned = String(val).replace(/%/g, '').trim();
            const n = parseFloat(cleaned);
            return isNaN(n) ? parseFloat(defaultRate) : n;
        };

        const parseExtraAssets = (rawList) => {
            let list = rawList;
            if (typeof list === 'string') {
                try { list = JSON.parse(list); } catch (e) { list = []; }
            }
            if (!Array.isArray(list)) return [];
            return list.map((item) => {
                const holding = parseNum(item.holding ?? item.value ?? item.numericHolding ?? 0);
                const rateVal = item.returnRate ?? item.ror ?? item.rate ?? 0;
                const rawRate = parseRate(rateVal, 0);
                return { holding, rawRate };
            });
        };

        const extraRetList = parseExtraAssets(inv.extra_retirement || userData?.extra_retirement);
        const extraLiqList = parseExtraAssets(inv.extra_liquid || userData?.extra_liquid);

        const retAssets = [
            { holding: parseNum(inv.epf_holding), rate: parseRate(getRetirementRate(0, "8.25%"), 8.25) },
            { holding: parseNum(inv.ppf_holding), rate: parseRate(getRetirementRate(1, "7.1%"), 7.1) },
            { holding: parseNum(inv.vpf_holding), rate: parseRate(getRetirementRate(2, "8.25%"), 8.25) },
            { holding: parseNum(inv.nps_holding), rate: parseRate(getRetirementRate(3, "10%"), 10) },
            { holding: parseNum(inv.other_retirement_investment_holding), rate: parseRate(getRetirementRate(4, "8%"), 8) },
            ...extraRetList.map(item => ({ holding: item.holding, rate: item.rawRate }))
        ];

        const liqAssets = [
            { holding: parseNum(inv.mf_holding), rate: parseRate(getLiquidRate(0, "12%"), 12) },
            { holding: parseNum(inv.stocks_holding), rate: parseRate(getLiquidRate(1, "12%"), 12) },
            { holding: parseNum(inv.bonds_holding), rate: parseRate(getLiquidRate(2, "8%"), 8) },
            { holding: parseNum(inv.fdrd_holding), rate: parseRate(getLiquidRate(3, "7%"), 7) },
            { holding: parseNum(inv.other_non_retirement_investment_holding), rate: parseRate(getLiquidRate(4, "10%"), 10) },
            ...extraLiqList.map(item => ({ holding: item.holding, rate: item.rawRate }))
        ];

        let totalRetHolding = 0, sumRetWeighted = 0;
        retAssets.forEach(a => {
            if (a.holding > 0) {
                totalRetHolding += a.holding;
                sumRetWeighted += a.holding * a.rate;
            }
        });

        let totalLiqHolding = 0, sumLiqWeighted = 0;
        liqAssets.forEach(a => {
            if (a.holding > 0) {
                totalLiqHolding += a.holding;
                sumLiqWeighted += a.holding * a.rate;
            }
        });

        const retWeightedAvg = totalRetHolding > 0
            ? (sumRetWeighted / totalRetHolding)
            : Number(userData?.investmentDetails?.retirement_weighted_return ?? userData?.planDetails?.cashflowParams?.weightedRPreROR ?? 8);

        const liqWeightedAvg = totalLiqHolding > 0
            ? (sumLiqWeighted / totalLiqHolding)
            : Number(userData?.investmentDetails?.liquid_weighted_return ?? userData?.planDetails?.cashflowParams?.weightedPreROR ?? 8);

        return {
            retWeightedAvg: (Math.round(retWeightedAvg * 100) / 100).toFixed(2),
            liqWeightedAvg: (Math.round(liqWeightedAvg * 100) / 100).toFixed(2),
            totalRetHolding,
            totalLiqHolding
        };
    };

    //finalBtn
    const handleDownloadPDF = async () => {
        setLoading(true)
        let pdfResult = await getPdfURL();
        setUrl(pdfResult?.url)
        console.log("get-pdf/pdf Response:  ", pdfResult);

        if (!pdfResult?.success) {
            console.log('pdf url is empty');
            return;
        }


        //////////////
        let firstDownload = downloadFlag;
        console.log('first download', firstDownload);
        setLoading(false);
        donwloadPDF(pdfResult.url);
        setDownloadFlag(true);
        localStorage.setItem('headerDownloadFlag', 'true');
        window.dispatchEvent(new Event('planConfirmed'));
        if ((previousPage == 'GoalDetail' || previousPage == 'GoalDetail.jsx') && firstDownload == false) {
            //////////////
            // Send email notification with download link
            //             try {
            //   const localtoken = localStorage.getItem("ssotoken");
            //   const rm_name  = localStorage.getItem('rm_name');
            //   const plan_ID = localStorage.getItem('plan_id');
            //   const rm_email = localStorage.getItem('rm_email');
            //   console.log("rm_email is", rm_email);
            //   const emailData = {
            //     plan_id : plan_ID,
            //      rm_name:rm_name,
            //      rm_email:rm_email
            //   };

            //   const result = await prpHttpAPI(emailData, 'get-pdf/send-email', null, "POST", null);
            //   if (result.success) {
            //     console.log("Email sent successfully.");
            //   }
            // } catch (error) {
            //   console.error("Error sending email:", error);
            // }

            /////////////
            const localtoken = localStorage.getItem("ssotoken");
            const result = await prpHttpAPI({ plan_id: versionedPlanId, send_notifications: true }, 'status', localtoken, "POST", null)

            if (result) {
                console.log("result in status api", result);
            }
        }



    }

    //new plan
    // const handleEdit = async () => {
    //     // Preserve only identity fields (name, phone, pan, email, rm) so the user
    //     // doesn't have to retype them. Clear everything that is plan-specific so
    //     // ClientDetails and subsequent pages don't inherit stale values.
    //     const rawData = localStorage.getItem('userData');
    //     if (rawData) {
    //         const existingData = JSON.parse(rawData);
    //         const cleanData = {
    //             ...existingData,
    //             client_name: existingData.client_name ?? "",
    //             pan_number: existingData.pan_number ?? "",
    //             spoc_rm: existingData.spoc_rm ?? existingData.rm_code ?? "",
    //             assign_plan: existingData.assign_plan ?? "",
    //             client_email: existingData.client_email ?? existingData.email_id ?? "",
    //             email_id: existingData.client_email ?? existingData.email_id ?? "",
    //             plan_id: existingData.plan_id ?? "",
    //             family_members: existingData.family_members ?? [],   // ADD THIS
    //         };
    //         localStorage.setItem('userData', JSON.stringify(cleanData));
    //     }
    //     localStorage.removeItem('clientInvestmentData');
    //     localStorage.removeItem('planDetails');
    //     navigate('/client-details?path=edit');
    // }

    // Compute GoalNetReq for each goal using same logic as GoalDetail.jsx
    // const computeGoalNetReq = (mergedResult) => {
    //     const goalNetReqMap = {};
    //     if (!mergedResult?.investmentDetails?.goals?.length) return goalNetReqMap;

    //     const d = mergedResult.investmentDetails;
    //     const CurrentYear = new Date().getFullYear();

    //     const retPct = {};
    //     (d.return_percent || []).forEach(r => { retPct[r.asset] = Number(r.return_percent) || 0; });
    //     const defRet = { mf: 12, stocks: 12, bonds: 8, fdrd: 7, other_liquid: 10 };
    //     const liq = {
    //         mf: Number(d.mf_holding) || 0,
    //         stocks: Number(d.stocks_holding) || 0,
    //         bonds: Number(d.bonds_holding) || 0,
    //         fdrd: Number(d.fdrd_holding) || 0,
    //         other_liquid: Number(d.other_non_retirement_investment_holding) || 0,
    //     };
    //     const totalLiq = Object.values(liq).reduce((s, v) => s + v, 0);
    //     let WPreRoR = 0.10;
    //     if (d.liquid_weighted_return !== undefined && d.liquid_weighted_return !== null && !isNaN(Number(d.liquid_weighted_return))) {
    //         WPreRoR = Number(d.liquid_weighted_return) / 100;
    //     } else if (totalLiq > 0) {
    //         const wSum = Object.entries(liq).reduce((s, [a, h]) =>
    //             s + h * (retPct[a] !== undefined ? retPct[a] : (defRet[a] || 0)), 0);
    //         WPreRoR = wSum / totalLiq / 100;
    //     } else if (d.pre_ret_ror) {
    //         WPreRoR = Number(d.pre_ret_ror) / 100;
    //     }

    //     const CRExpReturn = d.cr_exp_return ? Number(d.cr_exp_return) / 100 : 0.06;
    //     const capitalReceipts = d.capital_receipts || [];
    //     const otherLabel = d.other_non_retirement_label || 'Other Liquid';

    //     const remainingHoldingsPool = {
    //         'Mutual Funds': Number(d.mf_holding) || 0,
    //         'Stocks': Number(d.stocks_holding) || 0,
    //         'Bonds': Number(d.bonds_holding) || 0,
    //         'FD/RD': Number(d.fdrd_holding) || 0,
    //         [otherLabel]: Number(d.other_non_retirement_investment_holding) || 0,
    //     };
    //     const remainingSIPsPool = {
    //         'Mutual Funds': Number(d.mf_monthly) || 0,
    //         'Stocks': Number(d.stocks_monthly) || 0,
    //         'Bonds': Number(d.bonds_monthly) || 0,
    //         'FD/RD': Number(d.fdrd_monthly) || 0,
    //         [otherLabel]: Number(d.other_non_retirement_investment_monthly) || 0,
    //     };

    //     const crRemaining = capitalReceipts.map(r =>
    //         Number(String(r.amount || r.CRAmt || 0).replace(/,/g, ''))
    //     );

    //     const sortedGoals = [...d.goals]
    //         .map((g, idx) => {
    //             const GoalYear = Number(g.goal_year) || 0;
    //             const n = Math.max(0, GoalYear - CurrentYear);
    //             const inf = Number(g.expected_inflation || 5) / 100;
    //             const LoanFunding = Number(g.loan_amount || 0);
    //             const GoalAmtReq = Number(g.amount || 0);
    //             const GoalRequiredValue = Math.max(0, GoalAmtReq - LoanFunding) * Math.pow(1 + inf, n);
    //             return { g, idx, GoalYear, GoalRequiredValue, n };
    //         })
    //         .sort((a, b) => a.GoalYear - b.GoalYear || (b.idx - a.idx));

    //     let carriedSurplusCR = 0;
    //     let carriedSurplusInv = 0;
    //     let lastGoalYear = 0;
    //     let carriedSips = [];

    //     for (const { g, idx, GoalYear, GoalRequiredValue, n } of sortedGoals) {
    //         let goalHoldingSum = 0;
    //         let goalSipSum = 0;

    //         (g.additional_investment || []).forEach(row => {
    //             if (!row.name) return;
    //             const rawH = Number(row.amount || row.CurrentAvailable || 0);
    //             const rawS = Number(row.sip_amount || row.SIPAmt || 0);
    //             const aH = Math.min(rawH, remainingHoldingsPool[row.name] || 0);
    //             const aS = Math.min(rawS, remainingSIPsPool[row.name] || 0);
    //             remainingHoldingsPool[row.name] = Math.max(0, (remainingHoldingsPool[row.name] || 0) - aH);
    //             remainingSIPsPool[row.name] = Math.max(0, (remainingSIPsPool[row.name] || 0) - aS);
    //             goalHoldingSum += aH;
    //             goalSipSum += aS;
    //         });

    //         const InvestmentTaggedFV = goalHoldingSum * Math.pow(1 + WPreRoR, n);
    //         const AI = Number(g.stepup_sip || g.step_up || g.GrowthRate || 0) / 100;
    //         let MonthlyInvestmentFV = 0;
    //         if (n > 0 && goalSipSum > 0) {
    //             if (AI === 0) {
    //                 const r_m = WPreRoR / 12;
    //                 MonthlyInvestmentFV = r_m > 0
    //                     ? goalSipSum * ((Math.pow(1 + r_m, n * 12) - 1) / r_m)
    //                     : goalSipSum * n * 12;
    //             } else if (Math.abs(WPreRoR - AI) < 0.000001) {
    //                 MonthlyInvestmentFV = goalSipSum * 12 * n * Math.pow(1 + WPreRoR, n - 1);
    //             } else {
    //                 MonthlyInvestmentFV = goalSipSum * 12 *
    //                     (Math.pow(1 + WPreRoR, n) - Math.pow(1 + AI, n)) / (WPreRoR - AI);
    //             }
    //         }

    //         let remainingToSettle = GoalRequiredValue;
    //         let CapReceiptsAtGoalYear = 0;

    //         // 1. Carry CR surplus
    //         if (carriedSurplusCR > 0 && lastGoalYear > 0 && GoalYear >= lastGoalYear && remainingToSettle > 0) {
    //             const yrs = GoalYear - lastGoalYear;
    //             const compounded = carriedSurplusCR * Math.pow(1 + CRExpReturn, yrs);
    //             const apply = Math.min(compounded, remainingToSettle);
    //             CapReceiptsAtGoalYear += apply;
    //             remainingToSettle -= apply;
    //             carriedSurplusCR -= apply / Math.pow(1 + CRExpReturn, yrs);
    //         }

    //         // 2. Carry investment surplus
    //         if (carriedSurplusInv > 0 && lastGoalYear > 0 && GoalYear >= lastGoalYear && remainingToSettle > 0) {
    //             const yrs = GoalYear - lastGoalYear;
    //             const compounded = carriedSurplusInv * Math.pow(1 + WPreRoR, yrs);
    //             const apply = Math.min(compounded, remainingToSettle);
    //             CapReceiptsAtGoalYear += apply;
    //             remainingToSettle -= apply;
    //             carriedSurplusInv -= apply / Math.pow(1 + WPreRoR, yrs);
    //         }

    //         // 3. Capital receipts on remaining gap only
    //         for (let i = 0; i < capitalReceipts.length; i++) {
    //             if (remainingToSettle <= 0.01) break;
    //             if ((crRemaining[i] || 0) <= 0.01) continue;
    //             const CRYear = Number(capitalReceipts[i].year || capitalReceipts[i].CRYear || 0);
    //             if (GoalYear >= CRYear) {
    //                 const yrs = Math.max(0, GoalYear - CRYear);
    //                 const growthFactor = Math.pow(1 + CRExpReturn, yrs);
    //                 const maxFV = crRemaining[i] * growthFactor;
    //                 const crFV = Math.min(maxFV, remainingToSettle);
    //                 CapReceiptsAtGoalYear += crFV;
    //                 remainingToSettle -= crFV;
    //                 crRemaining[i] -= crFV / growthFactor;
    //             }
    //         }

    //         // 4. Carried SIPs
    //         if (carriedSips.length > 0 && GoalYear > 0) {
    //             let prevSipFV = 0;
    //             carriedSips.forEach(sip => {
    //                 if (GoalYear <= sip.PreviousGoalYear) return;
    //                 const yearsGap = GoalYear - sip.PreviousGoalYear;
    //                 const yearsToPrev = sip.PreviousGoalYear - CurrentYear;
    //                 const sipStart = sip.SIPAmt * Math.pow(1 + sip.AI, yearsToPrev);
    //                 if (Math.abs(WPreRoR - sip.AI) < 0.000001) {
    //                     prevSipFV += sipStart * 12 * ((Math.pow(1 + WPreRoR, yearsGap) - 1) / WPreRoR);
    //                 } else {
    //                     prevSipFV += sipStart * 12 *
    //                         (Math.pow(1 + WPreRoR, yearsGap) - Math.pow(1 + sip.AI, yearsGap)) /
    //                         (WPreRoR - sip.AI);
    //                 }
    //                 sip.PreviousGoalYear = GoalYear;
    //             });
    //             CapReceiptsAtGoalYear += prevSipFV;
    //             remainingToSettle -= prevSipFV;
    //         }

    //         // 5. Then deduct tagged holding FV (only what's needed)
    //         const holdingFVUsed = Math.min(InvestmentTaggedFV, remainingToSettle);
    //         remainingToSettle = Math.max(0, remainingToSettle - InvestmentTaggedFV);

    //         // 6. Then deduct tagged SIP FV (only what's needed)
    //         const sipFVUsed = Math.min(MonthlyInvestmentFV, remainingToSettle);
    //         remainingToSettle = Math.max(0, remainingToSettle - MonthlyInvestmentFV);

    //         // 7. Totals
    //         const TotalAvailable = holdingFVUsed + sipFVUsed + CapReceiptsAtGoalYear;
    //         const GoalNetReq = Math.max(0, GoalRequiredValue - TotalAvailable);
    //         const newSurplus = Math.max(0, TotalAvailable - GoalRequiredValue);

    //         // 8. Update surplus pools
    //         if (GoalNetReq > 0) {
    //             carriedSurplusCR = 0;
    //             carriedSurplusInv = 0;
    //         } else {
    //             if (carriedSurplusInv > 0 && lastGoalYear > 0 && GoalYear > lastGoalYear) {
    //                 carriedSurplusInv *= Math.pow(1 + WPreRoR, GoalYear - lastGoalYear);
    //             }
    //             carriedSurplusInv += newSurplus;
    //         }

    //         // 9. Register freed SIPs
    //         const currentAI = Number(g.stepup_sip || g.step_up || g.GrowthRate || 0) / 100;
    //         (g.additional_investment || []).forEach(row => {
    //             const rawS = Number(row.sip_amount || row.SIPAmt || 0);
    //             const aS = Math.min(rawS, remainingSIPsPool[row.name] || 0);
    //             if (aS > 0) {
    //                 carriedSips.push({ SIPAmt: aS, AI: currentAI, PreviousGoalYear: GoalYear });
    //             }
    //         });

    //         if (GoalYear > lastGoalYear) {
    //             lastGoalYear = GoalYear;
    //         }

    //         const key = `${g.goal_year}_${idx}`;
    //         goalNetReqMap[key] = GoalNetReq;
    //     }

    //     return goalNetReqMap;
    // };


    return (
        <>

            {userData ? <div className={styles.container}>
                <div className={styles.main}>
                    {/* {loading && <div>LOADING</div>} */}
                    {/* <nav className={`navbar bg-white p-3 fixed-top flex justify-content-end ${styles.pdfNav}`}>
       {!downloadFlag ?
       <div>
        <button onClick={handleBack} className="btn btn-outline-success me-4" type="button">Back</button>
        <button onClick={handleFinalPlan} className="btn btn-outline-danger" type="button">Finalise Plan</button>
        </div>
       : 
       <div>
       <button onClick={handlePlan} className="btn btn-outline-success me-4" type="button">Prepare a New Plan</button>
       <button onClick={handleDownloadPDF} className="btn btn-outline-danger" type="button">Download Pdf <span className='ps-2'> <img src={downloadIcon} alt="download-icon" /> </span></button>

       </div>
          }
        </nav> */}


                    <div className='pdf-page-one'>

                        {/* Top Header Banner */}
                        <div className={styles.topHeaderBanner}>
                            {/* Version Dropdown — left end */}
                            {versionList.length > 1 && (
                                <div className={styles.bannerVersionWrapper}>
                                    <label className={styles.bannerVersionLabel}>Version</label>
                                    <select
                                        className={styles.bannerVersionSelect}
                                        value={selectedVersion}
                                        onChange={handleVersionChange}
                                    >
                                        {versionList.map(v => (
                                            <option key={v} value={v}>V{v}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className={styles.bannerCenter}>
                                <span className={styles.bannerPlanId}>
                                    Plan ID: {
                                        userData?.clientsDetails?.plan_id ||
                                        JSON.parse(localStorage.getItem('userData') || '{}')?.plan_id ||
                                        '—'
                                    }
                                </span>
                            </div>
                            <div className={styles.bannerRight}>
                                <span className={styles.bannerDate}><span className={styles.bannerDate}>{formatDate(firstVersionDate || userData?.clientsDetails?.created_at)}</span></span>
                            </div>
                        </div>

                        {/* Angled Section Header */}
                        <div className={styles.headText}>
                            <div className={styles.belowHeaderLogoRow}>
                                <span className={styles.belowHeaderIncubatedBy}>Incubated By</span>
                                <img src={Logo} alt="Bajaj Capital" className={styles.belowHeaderLogo} />
                            </div>
                            <p>PRE-RETIREMENT PLAN</p>
                        </div>



                        <div className={styles.overviewSection}>
                            {/* Info Grid Section */}
                            <div className={styles.infoGridContainer}>
                                <div className={styles.infoGrid}>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>CLIENT</span>
                                        <span className={styles.infoValue}>
                                            {userData?.clientsDetails?.client_name ||
                                                JSON.parse(localStorage.getItem('userData') || '{}')?.client_name ||
                                                "—"}
                                        </span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>CURRENT AGE</span>
                                        <span className={styles.infoValue}>{userData?.clientsDetails?.age}Y</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>RETIREMENT YEAR</span>
                                        <span className={styles.infoValue}>{new Date().getFullYear() - (userData?.clientsDetails?.age || 0) + (userData?.clientsDetails?.year_of_retirement || 0)}</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>LIFE EXPECTANCY</span>
                                        <span className={styles.infoValue}>{userData?.clientsDetails?.life_expectancy}Y</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>ANNUAL INCOME</span>
                                        <span className={styles.infoValue}>₹{formatNumberToIndianUnits(userData?.clientsDetails?.annual_income || userData?.investmentDetails?.annual_income || 0)}</span>
                                    </div>

                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>INCOME GROWTH</span>
                                        <span className={styles.infoValue}>{userData?.clientsDetails?.annual_growth_rate || userData?.investmentDetails?.income_growth || 0}% p.a.</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>RETIREMENT AGE</span>
                                        <span className={styles.infoValue}>{userData?.clientsDetails?.year_of_retirement}Y</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>YEARS TO RETIREMENT</span>
                                        <span className={styles.infoValue}>{userData?.planDetails?.YearsUnitilRetirement}Y</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>RM</span>
                                        <span className={styles.infoValue}>
                                            {userData?.clientsDetails?.spoc_rm_name
                                                || userData?.clientsDetails?.spoc_rm
                                                || userData?.clientsDetails?.rm_code
                                                || (() => {
                                                    try {
                                                        return userData?.clientsDetails?.rm_details
                                                            ? JSON.parse(userData.clientsDetails.rm_details).name
                                                            : null;
                                                    } catch { return null; }
                                                })()
                                                || 'Advisor'}
                                        </span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>DATE CREATED</span>
                                        <span className={styles.infoValue}>{formatDate(firstVersionDate || userData?.clientsDetails?.created_at)}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Inflation/Goals Bar */}
                            {/* <div className={styles.summaryBar}>
                                <span>
                                    {userData?.investmentDetails?.goals?.length > 0
                                        ? [...userData.investmentDetails.goals].sort((a, b) => Number(a.goal_year) - Number(b.goal_year)).map((goal, idx) => {
                                            const goalIconMap = {
                                                'Child Education': '🎓',
                                                'Child Marriage': '💍',
                                                'Home Purchase': '🏠',
                                                'Vehicle': '🚗',
                                                'Vacation': '✈️',
                                                'Other Goals': '🎯',
                                            };
                                            const icon = goalIconMap[goal.goal_type] || '🎯';
                                            return (
                                                <span key={idx}>
                                                    {idx > 0 && <span style={{ margin: '0 6px', opacity: 0.5 }}>•</span>}
                                                    {icon} {goal.goal_type} — {goal.goal_name || goal.child_name}: {goal.expected_inflation || userData?.clientsDetails?.post_ret_inf }%
                                                </span>
                                            );
                                        })
                                        : 'No goals added'
                                    }
                                </span>
                            </div> */}

                            {/* Highlight Section */}
                            <div className={styles.highlightCardsContainer}>
                                {/* Monthly Expenses Card */}
                                <div className={styles.expenseCard}>
                                    <div className={styles.expenseCardCol}>
                                        <span className={styles.highlightLabel}>MONTHLY EXPENSES</span>
                                        <span className={styles.highlightValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.monthly_expenses))}</span>
                                        <span className={styles.highlightSub}>If retire today</span>
                                    </div>
                                    <div className={styles.expenseCardCol}>
                                        <span className={styles.highlightLabel}>AT RETIREMENT ({new Date().getFullYear() - (userData?.clientsDetails?.age || 0) + (userData?.clientsDetails?.year_of_retirement || 0)})</span>
                                        <span className={styles.highlightValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementExpanceRYMonthly))}</span>
                                        <span className={styles.highlightSub}>Inflation adjusted @ {userData?.clientsDetails?.pre_ret_inf}%</span>
                                    </div>
                                </div>

                                {/* Rates Card */}
                                <div className={styles.ratesCard}>
                                    <div className={styles.rateItem}>
                                        <span className={styles.highlightLabel}>Retirement Instruments Return <br />(Weighted Avg 🔒)</span>
                                        <span className={`${styles.rateValue} ${styles.rateValueGreen}`}>
                                            {getCalculatedWeightedReturns().retWeightedAvg}%
                                        </span>
                                    </div>
                                    <div className={styles.rateItem}>
                                        <span className={styles.highlightLabel}>Liquid Instruments Return <br />(Weighted Avg 🔒)</span>
                                        <span className={`${styles.rateValue} ${styles.rateValueGreen}`}>
                                            {getCalculatedWeightedReturns().liqWeightedAvg}%
                                        </span>
                                    </div>
                                    <div className={styles.rateItem}>
                                        <span className={styles.highlightLabel}>Post-Retirement Return</span>
                                        <span className={styles.rateValue}>{(() => {
                                            const raw = userData?.investmentDetails?.post_ret_ror ?? userData?.planDetails?.post_ret_ror ?? 0;
                                            const rounded = Math.round(Number(raw) * 2) / 2;
                                            return rounded % 1 === 0 ? rounded : rounded.toFixed(1);
                                        })()}%</span>
                                    </div>
                                    <div className={styles.rateItem}>
                                        <span className={styles.highlightLabel}>Pre-Retirement Inflation Rate</span>
                                        <span className={styles.rateValue}>{userData?.clientsDetails?.pre_ret_inf}%</span>
                                    </div>
                                    <div className={styles.rateItem}>
                                        <span className={styles.highlightLabel}>Post-Retirement Inflation Rate</span>
                                        <span className={styles.rateValue}>{userData?.clientsDetails?.post_ret_inf}%</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className={styles.financialSummaryBox}>
                            <div className={styles.financialSummaryTitle}>
                                <span>📋</span> Your Financial Health Summary
                            </div>
                            <div className={styles.financialSummaryText}>
                                {(() => {
                                    const currentYear = new Date().getFullYear();
                                    const crRate = userData.investmentDetails.cr_exp_return
                                        ? Number(userData.investmentDetails.cr_exp_return) / 100
                                        : 0.06;
                                    const capitalReceipts = userData.investmentDetails.capital_receipts || [];
                                    return (
                                        <>
                                            {userData.planDetails.shortageRYType === 'surplus'
                                                ? <>
                                                    Your retirement investments are projected at{' '}
                                                    <b>₹{formatNumberToIndianUnits(retInvProjected)}</b>
                                                    {unallocatedCapitalReceiptsFV > 0 && <>
                                                        , with a capital receipts surplus of{' '}
                                                        <b>₹{formatNumberToIndianUnits(unallocatedCapitalReceiptsFV)}</b>
                                                    </>}
                                                    {' '}and a liquid assets surplus of{' '}
                                                    <b>₹{formatNumberToIndianUnits(liquidSurplus)}</b>
                                                    {' '}— aggregating to a net value of{' '}
                                                    <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                                    {' '}against a retirement target of{' '}
                                                    <b>{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</b>.{' '}
                                                    A net surplus of{' '}
                                                    <b style={{ color: '#16a34a' }}>₹{formatNumberToIndianUnits(correctedSurplus)}</b> exists.{' '}
                                                    <span style={{ color: '#16a34a' }}>Your retirement corpus target is fully met — no additional SIP required.</span>
                                                </>
                                                : <>
                                                    Your retirement investments are projected at{' '}
                                                    <b>₹{formatNumberToIndianUnits(retInvProjected)}</b>
                                                    {unallocatedCapitalReceiptsFV > 0 && <>
                                                        , with a capital receipts surplus of{' '}
                                                        <b>₹{formatNumberToIndianUnits(unallocatedCapitalReceiptsFV)}</b>
                                                    </>}
                                                    {' '}and a liquid assets surplus of{' '}
                                                    <b>₹{formatNumberToIndianUnits(liquidSurplus)}</b>
                                                    {' '}— aggregating to a net value of{' '}
                                                    <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                                    {' '}against a retirement target of{' '}
                                                    <b>{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</b>.{' '}
                                                    A gap of <b style={{ color: '#dc2626' }}>{formatNumberToIndianUnits(correctedGap)}</b> exists.
                                                    An additional SIP of <b>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</b> is recommended.

                                                </>

                                            }
                                        </>
                                    );
                                })()}
                            </div>
                        </div>

                        {/* Plan Summary Section */}
                        <div className={styles.planSummaryCard}>
                            <div className={styles.planSummaryHeader}>
                                <div className={styles.planSummaryTitle}>
                                    📋 PLAN SUMMARY — {(userData?.clientsDetails?.client_name || JSON.parse(localStorage.getItem('userData') || '{}')?.client_name || 'CLIENT').toUpperCase()}
                                </div>
                                <div className={styles.planSummarySubtitle}>
                                    Prepared by {
                                        userData?.clientsDetails?.spoc_rm_name ||
                                        userData?.clientsDetails?.rm_name ||
                                        JSON.parse(localStorage.getItem('logged_rm_info') || '{}')?.EMP_NAME ||
                                        (() => {
                                            try {
                                                return userData?.clientsDetails?.rm_details
                                                    ? JSON.parse(userData.clientsDetails.rm_details).name
                                                    : null;
                                            } catch { return null; }
                                        })() ||
                                        JSON.parse(localStorage.getItem('userData') || '{}')?.spoc_rm_name ||
                                        JSON.parse(localStorage.getItem('userData') || '{}')?.rm_name ||
                                        'Advisor'
                                    } ({userData?.clientsDetails?.spoc_rm || userData?.clientsDetails?.rm_code || ''}) | {formatDate(firstVersionDate || userData?.clientsDetails?.created_at)}
                                </div>
                            </div>
                            <div className={styles.planSummaryContent}>
                                <p>
                                    Client (Age <b>{userData?.clientsDetails?.age}</b>) is planning to retire at <b>{userData?.clientsDetails?.year_of_retirement}</b>, with a life expectancy of <b>{userData?.clientsDetails?.life_expectancy} years</b> — leaving <b>{userData?.planDetails?.YearsUnitilRetirement} years to build</b> the corpus and <b>{userData?.planDetails?.retirementYears} years in retirement</b>. Current monthly expenses of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.monthly_expenses))}</b> will grow to <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementExpanceRYMonthly))}</b>/mo at retirement (@ {userData?.clientsDetails?.pre_ret_inf}% inflation).
                                </p>
                                <p>
                                    {userData.planDetails.shortageRYType === 'surplus' && Object.keys(goalsData).length > 0
                                        ? <p>
                                            Your combined financial assets — comprising Retirement Investments (
                                            <b>₹{formatNumberToIndianUnits(retInvProjected)}</b>
                                            ), Liquid Assets surplus post-goal mapping (
                                            <b>₹{formatNumberToIndianUnits(liquidSurplus)}</b>
                                            ){userData?.investmentDetails?.capital_receipts?.length > 0 && <>
                                                , and Capital Receipts surplus post-goal mapping (
                                                <b>₹{formatNumberToIndianUnits(unallocatedCapitalReceiptsFV)}</b>
                                                )</>} — aggregate to a net projected value of{' '}
                                            <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                            {userData.planDetails.shortageRYType === 'surplus'
                                                ? <>
                                                    , comfortably meeting the Retirement Target Corpus of{' '}
                                                    <b>{formatNumberToIndianUnits(targetCorpus)}</b>
                                                    , yielding a net surplus of{' '}
                                                    <b style={{ color: '#16a34a' }}>₹{formatNumberToIndianUnits(correctedSurplus)}</b>
                                                    .{' '}
                                                    <span style={{ color: '#16a34a' }}>No additional SIP contribution is required to achieve your retirement objective. ✓</span>
                                                </>
                                                : <>
                                                    , against a Retirement Target Corpus of{' '}
                                                    <b>{formatNumberToIndianUnits(targetCorpus)}</b> — leaving a{' '}
                                                    <b style={{ color: '#dc2626' }}>gap of {formatNumberToIndianUnits(correctedGap)}</b> to be addressed.
                                                </>
                                            }
                                        </p>
                                        : <>
                                            The <b>Retirement Target Corpus</b> is <b>{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</b>. Current investments of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.totalInvestments))}</b> (Ret: ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.RetirementInvestments))}, Liquid: ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))}) are projected to grow to <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                            {userData.planDetails.shortageRYType === 'surplus'
                                                ? <> — <span style={{ color: '#16a34a' }}>exceeding the target with a surplus of <b>₹{formatNumberToIndianUnits(
                                                    correctedSurplus
                                                )}</b>. No additional investment needed. ✓</span></>
                                                : <> — leaving a <b>gap of {formatNumberToIndianUnits(correctedGap)}</b> to be addressed.</>
                                            }
                                        </>
                                    }
                                </p>
                                {/* <p>
                                    {userData?.investmentDetails?.goals?.length > 0 ? (
                                        <span>
                                            <b>{userData.investmentDetails.goals.length} Life Goal{userData.investmentDetails.goals.length > 1 ? 's' : ''}</b> have been mapped:&nbsp;
                                            {[...userData.investmentDetails.goals].sort((a, b) => Number(a.goal_year) - Number(b.goal_year)).map((goal, idx) => {
                                                const goalIconMap = {
                                                    'Child Education': '🎓', 'Child Marriage': '💍',
                                                    'Home Purchase': '🏠', 'Vehicle': '🚗',
                                                    'Vacation': '✈️', 'Other Goals': '🎯',
                                                };
                                                const icon = goalIconMap[goal.goal_type] || '🎯';
                                                const name = goal.goal_name || goal.child_name || '';
                                                const goalKey = Object.keys(goalsData).find(k => goalsData[k].goals === goal);
                                                const isFulfilled = (goalNetReqMapRef.current[goalKey] ?? 1) < 1;
                                                return (
                                                    <span key={idx}>
                                                        {idx > 0 && ', '}
                                                        {icon} {goal.goal_type}{name ? ` — ${name}` : ''} ({goal.goal_year}{isFulfilled ? ' — Fulfilled ✓' : ''})
                                                    </span>
                                                );
                                            })}
                                        </span>
                                    ) : (
                                        "No specific goals have been mapped in this plan."
                                    )}
                                </p> */}
                                {userData?.investmentDetails?.capital_receipts?.length > 0 && (() => {
                                    const retCalYear = new Date().getFullYear()
                                        - (Number(userData?.clientsDetails?.age) || 0)
                                        + (Number(userData?.clientsDetails?.year_of_retirement) || 0);
                                    const totalRaw = userData.investmentDetails.capital_receipts.reduce((sum, r) => sum + checkForNullOrNaN(r.amount), 0);
                                    const preRetTotal = userData.investmentDetails.capital_receipts
                                        .filter(r => Number(r.year || r.CRYear || 0) < retCalYear)
                                        .reduce((sum, r) => sum + checkForNullOrNaN(r.amount), 0);
                                    const postRetTotal = userData.investmentDetails.capital_receipts
                                        .filter(r => Number(r.year || r.CRYear || 0) >= retCalYear)
                                        .reduce((sum, r) => sum + checkForNullOrNaN(r.amount), 0);
                                    return (
                                        <p>
                                            {/* <b>Capital receipts</b> totalling <b>₹{formatNumberToIndianUnits(totalRaw)}</b>, against which life goals have been mapped, leaving a surplus of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(unallocatedCapitalReceiptsFV))}</b>. These have been factored into the overall cash flow projections. <br /> */}

                                            {preRetTotal > 0 && <><b>Pre-retirement</b> Capital receipts totalling <b>₹{formatNumberToIndianUnits(preRetTotal)}</b>, against which life goals have been mapped, leaving a surplus of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(unallocatedCapitalReceiptsFV))}</b> <br /></>}

                                            {postRetTotal > 0 && <><b>Post-retirement</b> Capital receipts totalling <b>₹{formatNumberToIndianUnits(postRetTotal)}</b>, have been factored into the retirement target corpus.</>}

                                        </p>
                                    );
                                })()}
                                {(() => {
                                    const policies = userData?.investmentDetails?.insurance_coverage || [];
                                    const totalPremium = policies.reduce((sum, p) => sum + checkForNullOrNaN(p.premium), 0);
                                    const recommendedTerm = checkForNullOrNaN(userData?.planDetails?.insurance?.li_si);
                                    const recommendedHealth = checkForNullOrNaN(userData?.planDetails?.insurance?.hi_si);
                                    const totalTermCoverage = policies.filter(p => p.type === 'Term Insurance').reduce((sum, p) => sum + checkForNullOrNaN(p.coverage), 0);
                                    const totalHealthCoverage = policies.filter(p => p.type === 'Health Insurance').reduce((sum, p) => sum + checkForNullOrNaN(p.coverage), 0);
                                    const termGap = getTermInsuranceRows().reduce((sum, r) => sum + r.gap, 0);
                                    const healthGap = Math.max(0, recommendedHealth - totalHealthCoverage);
                                    if (policies.length === 0 && totalPremium === 0) return null;
                                    return (
                                        <p>
                                            <b>Insurance:</b> Total annual premium of <b>₹{Intl.NumberFormat('en-IN').format(totalPremium)}</b>.{' '}
                                            Term cover: {totalTermCoverage > 0 ? formatInsuranceValue(totalTermCoverage) : 'Not added'}{termGap > 0 ? ` (Gap: ${formatInsuranceValue(termGap)} — needs review)` : ' ✓'}.{' '}
                                            Health cover: {totalHealthCoverage > 0 ? formatInsuranceValue(totalHealthCoverage) : 'Not added'}{healthGap > 0 ? ` (Gap: ${formatInsuranceValue(healthGap)} — needs review)` : ' ✓'}.
                                        </p>
                                    );
                                })()}
                            </div>
                            <div className={styles.planSummaryBadges}>
                                <div className={styles.badgeItem}>
                                    🎯 Target Corpus {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}
                                </div>
                                <div className={styles.badgeItem}>
                                    📈 Projected ₹{formatNumberToIndianUnits(projectedTotalCorpus)}
                                </div>
                                <div className={styles.badgeItem}>
                                    {userData.planDetails.shortageRYType === 'surplus'
                                        ? '✅ No Additional SIP Required'
                                        : `📊 New SIP Recommended ₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo`
                                    }
                                </div>
                                {userData?.investmentDetails?.capital_receipts?.length > 0 && (() => {
                                    const crRate = userData.investmentDetails.cr_exp_return
                                        ? Number(userData.investmentDetails.cr_exp_return) / 100
                                        : 0.06;
                                    return (
                                        <div className={styles.badgeItem}>
                                            🏦 Capital Receipts {formatNumberToIndianUnits(unallocatedCapitalReceiptsFV)} <span style={{ fontSize: '0.7rem', opacity: 0.8 }}>(@{(crRate * 100).toFixed(0)}% grown, net of goals)</span>
                                        </div>
                                    );
                                })()}
                                {(() => {
                                    const totalPremium = (userData?.investmentDetails?.insurance_coverage || []).reduce((sum, p) => sum + checkForNullOrNaN(p.premium), 0);
                                    return totalPremium > 0 ? (
                                        <div className={styles.badgeItem}>
                                            💙 Insurance Premium ₹{Intl.NumberFormat('en-IN').format(totalPremium)}/yr
                                        </div>
                                    ) : null;
                                })()}
                                <div className={styles.badgeItem}>
                                    {userData.planDetails.shortageRYType === 'surplus'
                                        ? `🟢 Surplus: ₹${formatNumberToIndianUnits(correctedSurplus)}`
                                        : `⚠️ Status Gap: ${formatNumberToIndianUnits(correctedGap)}`
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Recommended SIP Section */}
                        <div className={styles.recommendedSipCard}>
                            <div className={styles.recommendedSipTitle}>
                                📊 RECOMMENDED SIP — GOALS & RETIREMENT CORPUS
                            </div>
                            {(() => {
                                // Goals strictly AFTER retirement year are excluded from this table entirely —
                                // neither shown as their own row nor folded into the Retirement Corpus SIP.
                                // The Retirement Corpus row mirrors correctedSIPMonthly, same as the
                                // Retirement Corpus Analysis card.
                                const retirementCalendarYear = new Date().getFullYear()
                                    - (userData?.clientsDetails?.age || 0)
                                    + (userData?.clientsDetails?.year_of_retirement || 0);

                                const sipTableGoalEntries = Object.entries(goalsData || {})
                                    .filter(([, data]) => (data.goals?.goal_year || 0) <= retirementCalendarYear)
                                    .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0));

                                const postRetirementGoalNames = Object.entries(goalsData || {})
                                    .filter(([, data]) => (data.goals?.goal_year || 0) > retirementCalendarYear)
                                    .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0))
                                    .map(([, data]) => data.goals?.goal_name || data.goals?.child_name || data.goals?.goal_type || 'Goal');

                                const retirementCorpusLabel = postRetirementGoalNames.length > 0
                                    ? `Retirement Corpus + ${formatList(postRetirementGoalNames)}`
                                    : 'Retirement Corpus (additional)';

                                const totalSipMonthly = Math.round(
                                    correctedSIPMonthly +
                                    (userData?.investmentDetails?.goals?.length > 0
                                        ? sipTableGoalEntries.reduce((acc, [, curr]) => acc + (checkForNullOrNaN(curr.additionalSavings) > 0 ? curr.additionalSavings : 0), 0)
                                        : 0)
                                );

                                return (
                                    <table className={styles.sipTable}>
                                        <thead>
                                            <tr>
                                                <th style={{ borderTopLeftRadius: "0rem" }}>GOAL / PURPOSE</th>
                                                <th>PERIOD</th>
                                                <th style={{ textAlign: "center" }}>STEP-UP</th>
                                                <th style={{ textAlign: "center" }}>GOAL INFLATION</th>
                                                <th style={{ textAlign: "right", borderTopRightRadius: "0rem" }}>MONTHLY SIP</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData?.investmentDetails?.goals?.length > 0 && sipTableGoalEntries.length > 0 ? (
                                                sipTableGoalEntries.map(([key, data], index) => {
                                                    const isFulfilled = checkForNullOrNaN(data.shortage) < 1;
                                                    const goalIconMap = {
                                                        'Child Education': '🎓', 'Child Marriage': '💍',
                                                        'Home Purchase': '🏠', 'Vehicle': '🚗',
                                                        'Vacation': '✈️', 'Other Goals': '🎯',
                                                    };
                                                    const icon = goalIconMap[data.goals?.goal_type] || '🎯';
                                                    const name = data.goals?.goal_name || data.goals?.child_name || 'N/A';
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <span style={{ marginRight: '6px' }}>{icon}</span>
                                                                {data.goals?.goal_type} — {name}
                                                            </td>
                                                            <td>{isFulfilled ? data.goals?.goal_year : `Now → ${data.goals?.goal_year}`}</td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {(() => {
                                                                    const stepUp = Number(data.goals?.stepup_sip || data.goals?.step_up || data.goals?.GrowthRate || 0);
                                                                    return stepUp > 0 ? `${stepUp}% p.a.` : '—';
                                                                })()}
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {(() => {
                                                                    const infl = data.goals?.expected_inflation;
                                                                    return infl ? `${infl}% p.a.` : "_";
                                                                })()}
                                                            </td>
                                                            <td style={{ textAlign: "right", color: isFulfilled ? "#15803d" : "inherit", fontWeight: isFulfilled ? "700" : "500" }}>
                                                                {isFulfilled
                                                                    ? "Fulfilled ✓"
                                                                    : `₹${Intl.NumberFormat('en-IN').format(Math.round(checkForNullOrNaN(data.additionalSavings)))}`
                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: "right", color: "#15803d", fontStyle: "italic", fontWeight: "700", padding: "1rem 0" }}>
                                                        <span style={{ marginRight: '5px' }}>✓</span> No goals added
                                                    </td>
                                                </tr>
                                            )}
                                            <tr className={styles.sipTableRowHighlighted}>
                                                <td><span style={{ marginRight: '8px' }}>🏦</span> {retirementCorpusLabel}</td>
                                                <td>{`Now → ${new Date().getFullYear() + checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement)}`}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                        try {
                                                            const inv = userData?.investmentDetails;
                                                            const annualInc = Number(
                                                                inv?.annual_increase_existing_investment ||
                                                                inv?.annual_increase ||
                                                                0
                                                            );
                                                            return annualInc > 0 ? `${annualInc}% p.a.` : '—';
                                                        } catch { return '—'; }
                                                    })()}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                        const postGoalEntries = Object.entries(goalsData || {})
                                                            .filter(([, data]) => (data.goals?.goal_year || 0) > retirementCalendarYear);
                                                        if (postGoalEntries.length === 0) return '_';
                                                        const inflations = postGoalEntries.map(([, data]) => {
                                                            const infl = data.goals?.expected_inflation;
                                                            return infl ? `${infl}% p.a.` : `${userData?.clientsDetails?.pre_ret_inf || 5}% p.a.`;
                                                        });
                                                        return `- | ${inflations.join(' | ')}`;
                                                    })()}
                                                </td>
                                                <td style={{ textAlign: "right", color: userData.planDetails.shortageRYType === 'surplus' ? '#16a34a' : 'inherit', fontWeight: userData.planDetails.shortageRYType === 'surplus' ? '700' : '500' }}>
                                                    {userData.planDetails.shortageRYType === 'surplus'
                                                        ? 'Not Required ✓'
                                                        : `₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}`
                                                    }
                                                </td>
                                            </tr>
                                            <tr className={styles.sipTableTotalRow}>
                                                <td colSpan="4" className={styles.sipTotalLabel}>Total New SIP Recommended</td>
                                                <td className={styles.sipTotalValue}>
                                                    {userData.planDetails.shortageRYType === 'surplus' && totalSipMonthly <= 0
                                                        ? <span style={{ color: '#16a34a' }}>₹0/mo — No SIP Needed ✓</span>
                                                        : `₹${Intl.NumberFormat('en-IN').format(totalSipMonthly)}/mo`
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                );
                            })()}
                            <div className={styles.sipNote}>
                                * Once a goal is achieved, that SIP amount is redirected to the next goal and ultimately to Retirement Corpus.
                            </div>
                        </div>

                        {/* Investment Table */}

                        <div className={styles.investmentDiv}>
                            <h3 className={styles.investmentHeading}>Investment Portfolio</h3>
                            <table className={styles.investmentTable}>
                                <thead>
                                    <tr>
                                        <th style={{ borderTopLeftRadius: "0rem" }}>INVESTMENT</th>
                                        <th style={{ textAlign: "right" }}>CURRENT HOLDING</th>
                                        <th style={{ textAlign: "right" }}>MONTHLY CONTRIBUTION</th>
                                        <th style={{ textAlign: "right", borderTopRightRadius: "0rem" }}>RETURN RATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(() => {
                                        const parseExtraAssets = (rawList, defaultPrefix) => {
                                            let list = rawList;
                                            if (typeof list === 'string') {
                                                try { list = JSON.parse(list); } catch (e) { list = []; }
                                            }
                                            if (!Array.isArray(list)) return [];
                                            return list.map((item, idx) => {
                                                const label = item.label || item.name || `${defaultPrefix} ${idx + 1}`;
                                                const holding = Number(String(item.holding ?? item.value ?? 0).replace(/,/g, '')) || 0;
                                                const monthly = Number(String(item.monthly ?? 0).replace(/,/g, '')) || 0;
                                                const rateVal = item.returnRate ?? item.ror ?? item.rate ?? 0;
                                                const rateStr = typeof rateVal === 'number' ? `${rateVal}%` : (String(rateVal).endsWith('%') ? String(rateVal) : `${rateVal}%`);
                                                return { label, holding, monthly, rate: rateStr };
                                            });
                                        };

                                        const extraRetirementList = parseExtraAssets(userData?.investmentDetails?.extra_retirement || userData?.extra_retirement, "Extra Ret");
                                        const extraLiquidList = parseExtraAssets(userData?.investmentDetails?.extra_liquid || userData?.extra_liquid, "Extra Non Ret");

                                        const totalRetHolding =
                                            checkForNullOrNaN(userData.investmentDetails.epf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.ppf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.vpf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.nps_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_holding) +
                                            extraRetirementList.reduce((sum, item) => sum + item.holding, 0);

                                        const totalRetMonthly =
                                            checkForNullOrNaN(userData.investmentDetails.epf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.ppf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.vpf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.nps_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_monthly) +
                                            extraRetirementList.reduce((sum, item) => sum + item.monthly, 0);

                                        const totalLiquidHolding =
                                            checkForNullOrNaN(userData.investmentDetails.mf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.stocks_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.bonds_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.fdrd_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_holding) +
                                            extraLiquidList.reduce((sum, item) => sum + item.holding, 0);

                                        const totalLiquidMonthly =
                                            checkForNullOrNaN(userData.investmentDetails.mf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.stocks_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.bonds_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.fdrd_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_monthly) +
                                            extraLiquidList.reduce((sum, item) => sum + item.monthly, 0);

                                        return (
                                            <>
                                                {/* Category: Retirement Investments */}
                                                <tr className={styles.categoryRow}>
                                                    <td colSpan="4">
                                                        <span className={`${styles.categoryDot}`}></span>🔴 RETIREMENT INVESTMENTS
                                                    </td>
                                                </tr>
                                                <tr className={styles.retirementRow}>
                                                    <td>EPF</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.epf_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.epf_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getRetirementRate(0, "8.25%"))}>{getRetirementRate(0, "8.25%")}</td>
                                                </tr>
                                                <tr className={styles.retirementRow}>
                                                    <td>PPF</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.ppf_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.ppf_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getRetirementRate(1, "7.1%"))}>{getRetirementRate(1, "7.1%")}</td>
                                                </tr>
                                                <tr className={styles.retirementRow}>
                                                    <td>VPF</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.vpf_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.vpf_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getRetirementRate(2, "8.25%"))}>{getRetirementRate(2, "8.25%")}</td>
                                                </tr>
                                                <tr className={styles.retirementRow}>
                                                    <td>NPS</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.nps_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.nps_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getRetirementRate(3, "10%"))}>{getRetirementRate(3, "10%")}</td>
                                                </tr>
                                                {(checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_holding) > 0 || checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_monthly) > 0) && (
                                                    <tr className={styles.retirementRow}>
                                                        <td>Other Ret.</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_holding))}</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_monthly))}</td>
                                                        <td style={{ textAlign: "right" }} className={getRateClass(getRetirementRate(4, "8%"))}>{getRetirementRate(4, "8%")}</td>
                                                    </tr>
                                                )}
                                                {extraRetirementList.map((item, idx) => (
                                                    <tr key={`extra_ret_${idx}`} className={styles.retirementRow}>
                                                        <td>{item.label}</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(item.holding)}</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(item.monthly)}</td>
                                                        <td style={{ textAlign: "right" }} className={getRateClass(item.rate)}>{item.rate}</td>
                                                    </tr>
                                                ))}
                                                {/* Retirement Total Row */}
                                                <tr className={styles.investmentTotalRow}>
                                                    <td>Total Retirement</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(totalRetHolding)}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(totalRetMonthly)}</td>
                                                    <td style={{ textAlign: "right" }}>
                                                        <span style={{ color: '#16a34a', fontSize: '0.78rem', fontWeight: '700' }}>
                                                            {getCalculatedWeightedReturns().retWeightedAvg}% (wtd avg)
                                                        </span>
                                                    </td>
                                                </tr>

                                                {/* Category: Liquid / Non-Retirement */}
                                                <tr className={styles.categoryRow}>
                                                    <td colSpan="4">
                                                        <span className={`${styles.categoryDot}`}></span> 🔵 LIQUID / NON-RETIREMENT
                                                    </td>
                                                </tr>
                                                <tr className={styles.liquidRow}>
                                                    <td>Mutual Funds</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.mf_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.mf_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getLiquidRate(0, "12%"))}>{getLiquidRate(0, "12%")}</td>
                                                </tr>
                                                <tr className={styles.liquidRow}>
                                                    <td>Stocks</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.stocks_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.stocks_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getLiquidRate(1, "12%"))}>{getLiquidRate(1, "12%")}</td>
                                                </tr>
                                                <tr className={styles.liquidRow}>
                                                    <td>Bonds</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.bonds_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.bonds_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getLiquidRate(2, "8%"))}>{getLiquidRate(2, "8%")}</td>
                                                </tr>
                                                <tr className={styles.liquidRow}>
                                                    <td>FD / RD</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.fdrd_holding))}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.fdrd_monthly))}</td>
                                                    <td style={{ textAlign: "right" }} className={getRateClass(getLiquidRate(3, "7%"))}>{getLiquidRate(3, "7%")}</td>
                                                </tr>
                                                {(checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_holding) > 0 || checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_monthly) > 0) && (
                                                    <tr className={styles.liquidRow}>
                                                        <td>Other Non Ret.</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_holding))}</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_monthly))}</td>
                                                        <td style={{ textAlign: "right" }} className={getRateClass(getLiquidRate(4, "10%"))}>{getLiquidRate(4, "10%")}</td>
                                                    </tr>
                                                )}
                                                {extraLiquidList.map((item, idx) => (
                                                    <tr key={`extra_liq_${idx}`} className={styles.liquidRow}>
                                                        <td>{item.label}</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(item.holding)}</td>
                                                        <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(item.monthly)}</td>
                                                        <td style={{ textAlign: "right" }} className={getRateClass(item.rate)}>{item.rate}</td>
                                                    </tr>
                                                ))}

                                                <tr className={styles.investmentTotalRow}>
                                                    <td style={{ borderBottomLeftRadius: "0rem" }}>Total Non-Retirement</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(totalLiquidHolding)}</td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(totalLiquidMonthly)}</td>
                                                    <td style={{ textAlign: "right", borderBottomRightRadius: "0rem" }}>
                                                        <span style={{ color: '#16a34a', fontSize: '0.78rem', fontWeight: '700' }}>
                                                            {getCalculatedWeightedReturns().liqWeightedAvg}% (wtd avg)
                                                        </span>
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })()}
                                </tbody>
                            </table>
                        </div>

                        {/* Capital Receipts Section */}
                        <div className={styles.capitalReceiptsDiv}>
                            <h3 className={styles.investmentHeading}>Capital Receipts</h3>
                            <table className={styles.receiptsTable}>
                                <thead>
                                    <tr>
                                        <th style={{ borderTopLeftRadius: "0rem" }}>DESCRIPTION</th>
                                        <th>YEAR</th>
                                        <th style={{ textAlign: "right", borderTopRightRadius: "0rem" }}>AMOUNT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userData?.investmentDetails?.capital_receipts?.length > 0 ? (
                                        userData.investmentDetails.capital_receipts.map((receipt, index) => {
                                            const receiptYear = Number(receipt.year || receipt.CRYear || 0);
                                            const retirementCalendarYear = new Date().getFullYear()
                                                - (Number(userData?.clientsDetails?.age) || 0)
                                                + (Number(userData?.clientsDetails?.year_of_retirement) || 0);
                                            const isAfterRetirement = receiptYear > 0 && retirementCalendarYear > 0 && receiptYear > retirementCalendarYear;
                                            return (
                                                <tr key={index}>
                                                    <td>{receipt.description || receipt.CRName || 'N/A'}</td>
                                                    <td>
                                                        {receipt.year || receipt.CRYear || 'N/A'}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(receipt.amount))}
                                                        <b>  {isAfterRetirement ? ' [adjusted in retirement corpus]' : ''}</b>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className={styles.receiptsEmpty} style={{ borderBottomLeftRadius: "0rem", borderBottomRightRadius: "0rem" }}>No capital receipts added</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Summary Retirement Analysis Section */}
                        <div className={styles.capitalReceiptsDiv}>
                            <h3 className={styles.investmentHeading}>Retirement Analysis</h3>
                            <p className={styles.retirementSubText} style={{ marginLeft: '10px' }}>
                                {checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement)} Years to Retirement • {checkForNullOrNaN(userData.planDetails.retirementYears)} Years in Retirement
                            </p>
                            <div className={styles.summaryAnalysisGrid}>
                                <div className={styles.summaryAnalysisCard}>
                                    <div className={styles.summaryAnalysisLabel}>TOTAL INVESTMENTS</div>
                                    <div className={styles.summaryAnalysisValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.totalInvestments))}</div>
                                    <div className={styles.summaryAnalysisSplit}>
                                        Ret: <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.RetirementInvestments))}</b> | Liquid: <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))}</b>
                                    </div>
                                </div>
                                <div className={styles.summaryAnalysisCard}>
                                    <div className={styles.summaryAnalysisLabel}>TOTAL MONTHLY SIP</div>
                                    <div className={styles.summaryAnalysisValue}>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.TotalContributions))}</div>
                                    <div className={styles.summaryAnalysisSplit}>
                                        Ret: <b>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.RetirementContributions))}</b> | Liquid: <b>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))}</b>
                                    </div>
                                </div>
                                <div className={styles.summaryAnalysisCard}>
                                    <div className={styles.summaryAnalysisLabel}>RETIREMENT TARGET CORPUS</div>
                                    <div className={`${styles.summaryAnalysisValue} ${styles.summaryAnalysisValueCr}`}>
                                        {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}
                                    </div>
                                    <div className={styles.summaryAnalysisSplit}>
                                        Projected: <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                        {userData.planDetails.shortageRYType === 'surplus' && <span style={{ color: '#16a34a' }}> ✓ Surplus</span>}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.summaryAnalysisFooter}>
                                Retirement Goal: <span className={styles.goalPercent} style={{ color: retPercent >= 100 ? '#16a34a' : 'inherit' }}>{retPercent >= 100 ? '100%+ ✓' : `${retPercent}%`}</span>
                                {' '}— Projected ₹{formatNumberToIndianUnits(projectedTotalCorpus)} vs Target {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}
                                {userData.planDetails.shortageRYType === 'surplus' && <span style={{ color: '#16a34a', marginLeft: '8px' }}>— Target fully met ✓</span>}
                            </div>
                        </div>


                    </div>

                    {/* Goal Details Section */}
                    <div className={styles.goalDetailsSection}>
                        <h3 className={styles.investmentHeading} style={{ marginLeft: "10px" }}>Goal-wise Analysis</h3>
                        {goalsData && Object.keys(goalsData).length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                {Object.entries(goalsData)
                                    .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0))
                                    .map(([key, data], index) => {
                                        const goalIconMap = {
                                            'Child Education': '🎓', 'Child Marriage': '💍',
                                            'Home Purchase': '🏠', 'Vehicle': '🚗',
                                            'Vacation': '✈️', 'Other Goals': '🎯',
                                        };
                                        const icon = goalIconMap[data.goals?.goal_type] || '🎯';
                                        const GoalYear = data.goals?.goal_year || 0;
                                        const currentYear = new Date().getFullYear();
                                        const yrsAway = Math.max(0, GoalYear - currentYear);
                                        const retirementCalendarYear = currentYear
                                            - (userData?.clientsDetails?.age || 0)
                                            + (userData?.clientsDetails?.year_of_retirement || 0);
                                        const isPostRetirementGoal = GoalYear > retirementCalendarYear;
                                        const retRate = Number(userData?.planDetails?.cashflowParams?.weightedPreROR) || 12;
                                        const inflation = data.goals?.expected_inflation || userData?.clientsDetails?.post_ret_inf || userData?.clientsDetails?.inflation_rate || 5;
                                        const taggedInvestments = data.goals?.additional_investment || [];
                                        const capitalReceiptsList = userData?.investmentDetails?.capital_receipts || [];
                                        const taggedFV =
                                            Number(data.taggedInvestmentsFV || 0) +
                                            Number(data.monthlyInvestmentFV || 0);

                                        const crFV = Number(data.capitalReceiptFV || 0);

                                        //mapped to goal in Goal-wise Analysis

                                        const amountRequiredNum = checkForNullOrNaN(data.amountRequired);
                                        const isFulfilled = (taggedFV + crFV) >= amountRequiredNum;

                                        let mappedToGoalValue;
                                        let surplus = 0;
                                        let shortfallAmount = 0;

                                        if (!isFulfilled) {
                                            // Rule 1: Shortfall
                                            mappedToGoalValue = crFV;
                                            shortfallAmount = amountRequiredNum - (taggedFV + crFV);
                                        } else if (crFV > amountRequiredNum) {
                                            // Rule 2: CR/Carried Surplus > Target — Surplus = CR/Carried Surplus (FV) - Inflation-Adj. Target
                                            mappedToGoalValue = amountRequiredNum;
                                            surplus = crFV - amountRequiredNum;
                                        } else if ((taggedFV + crFV) > amountRequiredNum) {
                                            // Rule 3: Total available > Target
                                            mappedToGoalValue = crFV;
                                            surplus = (taggedFV + crFV) - amountRequiredNum;
                                        } else {
                                            mappedToGoalValue = crFV;
                                            surplus = 0;
                                        }

                                        const gridCols = 'repeat(5, 1fr)';

                                        return (
                                            <div key={key} className={`${styles.goalCard} ${isFulfilled ? styles.goalCardFunded : styles.goalCardShortfall}`}>
                                                {/* ── Header ── */}
                                                <div className={styles.goalCardHeader}>
                                                    <div>
                                                        <div className={styles.goalCardTitle}>
                                                            {icon} {data.goals?.goal_type} — {data.goals?.goal_name || data.goals?.child_name}
                                                        </div>
                                                        <div className={styles.goalCardMeta}>
                                                            <span>Target Year: <b>{GoalYear}</b></span>
                                                            <span className={styles.goalCardMetaDivider}>|</span>
                                                            <span>{yrsAway} yrs away</span>
                                                            <span className={styles.goalCardMetaDivider}>|</span>
                                                            <span>Return: <b>{retRate.toFixed(2)}%</b></span>
                                                            <span className={styles.goalCardMetaDivider}>|</span>
                                                            <span>Inflation: <b>{inflation}%</b></span>
                                                        </div>
                                                    </div>
                                                    {!isPostRetirementGoal && (
                                                        <span className={styles.goalCardBadge}>
                                                            {isFulfilled ? 'Funded ✓' : 'Shortfall ⚠️'}
                                                        </span>
                                                    )}
                                                </div>
                                                {isPostRetirementGoal ? (
                                                    <>
                                                        <div className={styles.goalCardStatsGrid} style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>Current Value (Today)</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {Number(data.goals?.amount) > 0 ? formatNumberToIndianUnits(Number(data.goals?.amount)) : '₹0'}
                                                                </div>
                                                            </div>
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>Inflation-Adj. Target</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {formatNumberToIndianUnits(checkForNullOrNaN(data.amountRequired))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={styles.goalCardFooter}>
                                                            <span style={{ fontWeight: 'bolder' }}> ℹ️&nbsp;As this goal is scheduled to occur after retirement, it is incorporated directly into the Retirement corpus target, hence no need to allocate liquid assets.</span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>

                                                        {/* ── Stats Grid ── */}
                                                        <div className={styles.goalCardStatsGrid} style={{ gridTemplateColumns: gridCols }}>
                                                            {/* Col 1: Current Value */}
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>Current Value (Today)</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {Number(data.goals?.amount) > 0 ? formatNumberToIndianUnits(Number(data.goals?.amount)) : '₹0'}
                                                                </div>
                                                            </div>

                                                            {/* Col 2: Inflation-Adj Target */}
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>Inflation-Adj. Target</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {formatNumberToIndianUnits(checkForNullOrNaN(data.amountRequired))}
                                                                </div>
                                                            </div>

                                                            {/* Col 2: Tagged Investments FV */}
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>Tagged Investments (FV)</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {taggedFV > 0 ? formatNumberToIndianUnits(taggedFV) : '₹0'}
                                                                </div>
                                                            </div>

                                                            {/* Col 3: Mapped CR / Carried Surplus (FV) */}
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>CR / Carried Surplus (FV)</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {crFV > 0 ? formatNumberToIndianUnits(crFV) : '₹0'}
                                                                </div>
                                                            </div>

                                                            {/* Col 4: Surplus / Shortfall */}
                                                            <div className={styles.goalStatBox}>
                                                                <div className={styles.goalStatBoxLabel}>{isFulfilled ? 'Surplus' : 'Shortfall'}</div>
                                                                <div className={styles.goalStatBoxValue}>
                                                                    {isFulfilled
                                                                        ? `₹${formatNumberToIndianUnits(surplus)}`
                                                                        : formatNumberToIndianUnits(shortfallAmount)
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* ── Footer ── */}
                                                        <div className={styles.goalCardFooter}>
                                                            <span>Total Projected: <b>{formatNumberToIndianUnits(checkForNullOrNaN(data.amountRequired))}</b></span>
                                                            <span className={styles.goalCardFooterDivider}>|</span>
                                                            {isFulfilled ? (
                                                                <span>Surplus cascades to next goal / retirement</span>
                                                            ) : (
                                                                <span>Additional SIP: ₹{Intl.NumberFormat('en-IN').format(Math.round(checkForNullOrNaN(data.additionalSavings)))}/mo OR Lumpsum: {formatNumberToIndianUnits(checkForNullOrNaN(data.addinonalLumsum))}</span>
                                                            )}
                                                        </div>

                                                        {/* ── CR detail row ── */}
                                                        {(() => {
                                                            const CRExpReturn = userData?.investmentDetails?.cr_exp_return
                                                                ? Number(userData.investmentDetails.cr_exp_return) / 100
                                                                : 0.06;

                                                            // Total cumulative FV of all CRs at goal year (current year's + previous years', if present)
                                                            const crSnapshot = data.crRemainingSnapshot || [];
                                                            const totalCRFVAtGoalYear = capitalReceiptsList.reduce((sum, r, i) => {
                                                                const crYear = Number(r.year || r.CRYear || 0);
                                                                const remainingPrincipal = (crSnapshot[i] !== undefined && crSnapshot[i] !== null)
                                                                    ? crSnapshot[i]
                                                                    : Number(String(r.amount || r.CRAmt || 0).replace(/,/g, ''));
                                                                if (crYear <= GoalYear) {
                                                                    const yrs = Math.max(0, GoalYear - crYear);
                                                                    return sum + remainingPrincipal * Math.pow(1 + CRExpReturn, yrs);
                                                                }
                                                                return sum;
                                                            }, 0);

                                                            // Cascaded surplus now comes straight from the cascade
                                                            // (previous-goal surplus + freed SIP FV) instead of subtraction.
                                                            const cascadedLiquidSurplus = checkForNullOrNaN(data.cascadedSurplusFV);

                                                            const mappedToGoalDisplay = `₹${formatNumberToIndianUnits(mappedToGoalValue)}`;

                                                            const parts = [
                                                                { label: 'Goal-year capital receipts', value: `₹${formatNumberToIndianUnits(totalCRFVAtGoalYear)}` },
                                                                { label: 'Cascaded liquid surplus', value: `₹${formatNumberToIndianUnits(cascadedLiquidSurplus)}` },
                                                                { label: 'Mapped to goal', value: mappedToGoalDisplay },
                                                            ];

                                                            return (
                                                                <div style={{
                                                                    padding: '8px 18px 10px', background: '#fafafa',
                                                                    borderTop: '1px dashed #e2e8f0', fontSize: '0.78rem',
                                                                    color: '#555', lineHeight: '1.7'
                                                                }}>
                                                                    {parts.map((part, i) => (
                                                                        <span key={part.label}>
                                                                            {i > 0 && <span style={{ margin: '0 8px', opacity: 0.5 }}>|</span>}
                                                                            {part.label}: <b>{part.value}</b>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            );
                                                        })()}
                                                        {/* ── Tagged investments row ── */}
                                                        {taggedInvestments.filter(t => t.name).length > 0 && (
                                                            <div style={{ padding: '8px 18px 12px', background: '#f8fafc', borderTop: '1px dashed #e2e8f0', fontSize: '0.78rem', color: '#64748b' }}>
                                                                📌 {taggedInvestments.filter(t => t.name).map((t, i) => (
                                                                    <span key={i}>
                                                                        {i > 0 && ' | '}
                                                                        {t.name}: ₹{Intl.NumberFormat('en-IN').format(Number(t.amount || t.CurrentAvailable || 0))}
                                                                        {Number(t.sip_amount || t.SIPAmt || 0) > 0 && ` (SIP ₹${Intl.NumberFormat('en-IN').format(Number(t.sip_amount || t.SIPAmt))}/mo)`}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* ── Recommended Allocation ── INSIDE the goal card, BEFORE </div> ── */}
                                                        {(() => {
                                                            const alloc = getAllocationForGoal(yrsAway, retRate);
                                                            const monthlySIP = Math.round(checkForNullOrNaN(data.additionalSavings));
                                                            const COLORS = { equity: '#2a78d6', debt: '#6fa287', cash: '#eb6834', gold: '#eda100', silver: '#898781' };
                                                            return (
                                                                <div style={{ padding: '14px 18px 16px', borderTop: '1px solid #e2e8f0', background: '#fafafa' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px', flexWrap: 'wrap' }}>
                                                                        <span style={{ fontSize: '0.72rem', fontWeight: '800', color: '#1baf7a', letterSpacing: '0.06em', textTransform: 'uppercase' }}>RECOMMENDED ALLOCATION</span>
                                                                    </div>

                                                                    {isFulfilled ? (
                                                                        <div style={{ fontSize: '0.82rem', color: '#6fa287', fontWeight: '600' }}>Goal is fully funded — no additional SIP required ✓</div>
                                                                    ) : monthlySIP > 0 ? (
                                                                        <>
                                                                            <div style={{ fontSize: '0.82rem', color: '#334155', marginBottom: '10px' }}>
                                                                                Invest <b>₹{Intl.NumberFormat('en-IN').format(monthlySIP)}/mo</b> across this mix
                                                                            </div>
                                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                                                {[
                                                                                    { label: 'Equity', pct: alloc.Equity, color: COLORS.equity },
                                                                                    { label: 'Debt', pct: alloc.Bond, color: COLORS.debt },
                                                                                    { label: 'Cash', pct: alloc.Cash, color: COLORS.cash },
                                                                                    { label: 'Gold', pct: alloc.Gold, color: COLORS.gold },
                                                                                    { label: 'Silver', pct: alloc.Silver, color: COLORS.silver },
                                                                                ].filter(c => c.pct > 0).sort((a, b) => b.pct - a.pct).map(c => {
                                                                                    return (
                                                                                        <div key={c.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1.5px solid #e0e0e0', borderRadius: '8px', padding: '5px 10px', minWidth: '60px', background: '#fff' }}>
                                                                                            <span style={{ fontSize: '0.65rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#555', opacity: 0.8 }}>{c.label}</span>
                                                                                            <span style={{ fontSize: '0.82rem', fontWeight: '800', color: '#222' }}>{c.pct}%</span>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            );
                                                        })()}
                                                    </>
                                                )}
                                            </div>
                                        );
                                        {/* ── Recommended Allocation for this goal ── */ }
                                        {
                                            (() => {
                                                const GoalYear = data.goals?.goal_year || 0;
                                                const currentYear = new Date().getFullYear();
                                                const yearsAway = Math.max(0, GoalYear - currentYear);
                                                const ror = userData?.investmentDetails?.pre_ret_ror || 12;
                                                const alloc = getAllocationForGoal(yearsAway, ror);
                                                const monthlySIP = Math.round(checkForNullOrNaN(data.additionalSavings));
                                                const COLORS = { equity: '#2a78d6', debt: '#1baf7a', cash: '#eb6834', gold: '#eda100', silver: '#898781' };

                                                return (
                                                    <div style={{ padding: '14px 18px 16px', borderTop: '1px solid #e2e8f0', background: '#fafafa' }}>
                                                        {/* Header */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px', flexWrap: 'wrap' }}>
                                                            <span style={{ fontSize: '0.72rem', fontWeight: '800', color: '#4E6137', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                                                                RECOMMENDED ALLOCATION
                                                            </span>
                                                        </div>

                                                        {/* Callout + chips */}
                                                        {isFulfilled ? (
                                                            <div style={{ fontSize: '0.82rem', color: '#4E6137', fontWeight: '600' }}>
                                                                Goal is fully funded — no additional SIP required ✓
                                                            </div>
                                                        ) : monthlySIP > 0 ? (
                                                            <>
                                                                <div style={{ fontSize: '0.82rem', color: '#334155', marginBottom: '10px' }}>
                                                                    Invest <b>₹{Intl.NumberFormat('en-IN').format(monthlySIP)}/mo</b> across this mix
                                                                </div>
                                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                                    {[
                                                                        { label: 'Equity', pct: alloc.Equity, color: COLORS.equity },
                                                                        { label: 'Debt', pct: alloc.Bond, color: COLORS.debt },
                                                                        { label: 'Cash', pct: alloc.Cash, color: COLORS.cash },
                                                                        { label: 'Gold', pct: alloc.Gold, color: COLORS.gold },
                                                                        { label: 'Silver', pct: alloc.Silver, color: COLORS.silver },
                                                                    ].filter(c => c.pct > 0).map(c => {
                                                                        const amt = Math.round((c.pct / 100) * monthlySIP);
                                                                        return (
                                                                            <div key={c.label} style={{
                                                                                display: 'flex', flexDirection: 'column', alignItems: 'center',
                                                                                border: '1.5px solid #e0e0e0', borderRadius: '8px',
                                                                                padding: '5px 10px', minWidth: '70px', background: '#fff',
                                                                            }}>
                                                                                <span style={{ fontSize: '0.65rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#555', opacity: 0.8 }}>{c.label}</span>
                                                                                <span style={{ fontSize: '0.82rem', fontWeight: '800', color: '#222' }}>₹{Intl.NumberFormat('en-IN').format(amt)}</span>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </>
                                                        ) : null}
                                                    </div>
                                                );
                                            })()
                                        }
                                    })}
                            </div>
                        ) : (
                            <p className={styles.goalsEmpty}>No goals added. Add goals in the Goals tab.</p>
                        )}
                    </div>
                    {/* Retirement Corpus Analysis Section */}
                    <div className={styles.goalDetailsSection}>
                        <h3 className={styles.investmentHeading}>Retirement Corpus Analysis</h3>
                        <div className={styles.corpusAnalysisDiv}>
                            <div className={styles.corpusStatGrid}>
                                <div className={styles.corpusStatCard}>
                                    <div className={styles.corpusStatLabel}>TARGET CORPUS</div>
                                    <div className={`${styles.corpusStatValue} ${styles.valueRed}`}>
                                        {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}
                                    </div>
                                    <div className={styles.corpusStatSub}>Adjusted for Post-Ret-Goals</div>
                                </div>
                                <div className={styles.corpusStatCard}>
                                    <div className={styles.corpusStatLabel}>PROJECTED CORPUS</div>
                                    <div className={`${styles.corpusStatValue} ${styles.valueRed}`}>
                                        ₹{formatNumberToIndianUnits(projectedTotalCorpus)}
                                    </div>
                                    <div className={styles.corpusStatSub}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a' }}>
                                                Surplus: ₹{formatNumberToIndianUnits(
                                                    correctedSurplus
                                                )}
                                            </span>
                                            : 'With retirement investments'
                                        }
                                    </div>
                                </div>
                                <div className={styles.corpusStatCard}>
                                    <div className={styles.corpusStatLabel}>ADDITIONAL SIP NEEDED</div>
                                    <div className={`${styles.corpusStatValue} ${styles.valueBlue}`}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a' }}>Not Required ✓</span>
                                            : `₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo`
                                        }
                                    </div>
                                    <div className={styles.corpusStatSub}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? 'Corpus target already met'
                                            : 'After goal SIPs redirect in'
                                        }
                                    </div>
                                </div>
                            </div>

                            {/*
                            <table className={styles.corpusTable}>
                                <thead>
                                    <tr>
                                        <th style={{borderTopLeftRadius:"0rem"}}>PHASE</th>
                                        <th>PERIOD</th>
                                        <th>GOAL SIP (NET)</th>
                                        <th>REDIRECTS TO RETIREMENT</th>
                                        <th style={{ textAlign: 'center', borderTopRightRadius:"0rem" }}>STEP-UP</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className={styles.corpusTableRowHighlight}>
                                        <td>All goals achieved → Full SIP to Retirement</td>
                                        <td>{(Number(userData.clientsDetails?.current_year) || new Date().getFullYear()) + Number(checkForNullOrNaN(userData.planDetails?.YearsUnitilRetirement))} (Retirement)</td>
                                        <td>—</td>
                                        <td>₹0/mo total</td>
                                        <td>Reduces gap</td>
                                    </tr>
                                </tbody>
                            </table>
                            */}

                            {/* ── Retirement Recommended Allocation ── */}
                            {userData.planDetails.shortageRYType !== 'surplus' && (
                                <div style={{ marginTop: '1rem', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden', background: '#fafafa' }}>
                                    <div style={{ padding: '16px 20px 18px' }}>
                                        {/* Header */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px', flexWrap: 'wrap' }}>
                                            <span style={{ fontSize: '0.72rem', fontWeight: '800', color: '#4E6137', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                                                RECOMMENDED ALLOCATION
                                            </span>
                                        </div>

                                        {/* Bars */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', marginBottom: '12px' }}>
                                            {[
                                                { label: 'Equity', pct: equityPct, color: '#2a78d6' },
                                                { label: 'Debt', pct: debtPct, color: '#6fa287' },
                                                { label: 'Cash', pct: cashPct, color: '#eb6834' },
                                                { label: 'Gold', pct: goldPct, color: '#eda100' },
                                                { label: 'Silver', pct: silverPct, color: '#94a3b8' },
                                            ].filter(b => b.pct > 0).sort((a, b) => b.pct - a.pct).map(b => (
                                                <div key={b.label} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{ fontSize: '0.78rem', fontWeight: '600', color: '#555', minWidth: '52px' }}>{b.label}</span>
                                                    <div style={{ flex: 1, height: '8px', background: '#e2e8f0', borderRadius: '4px', overflow: 'hidden' }}>
                                                        <div style={{ width: `${b.pct}%`, height: '100%', background: b.color, borderRadius: '4px' }} />
                                                    </div>
                                                    <span style={{ fontSize: '0.78rem', fontWeight: '700', color: '#333', minWidth: '32px', textAlign: 'right' }}>{b.pct}%</span>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Callout + chips */}
                                        {correctedSIPMonthly > 0 ? (
                                            <>
                                                <div style={{ fontSize: '0.82rem', color: '#334155', marginBottom: '10px' }}>
                                                    Invest <b>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</b> across this mix
                                                </div>
                                            </>
                                        ) : null}

                                        {/* ── Products available to build this mix ── */}
                                        <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #e2e8f0' }}>
                                            <div style={{ fontSize: '0.9rem', fontWeight: '700', color: '#1e293b' }}>Products available to build this mix</div>
                                            <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: '2px', marginBottom: '10px' }}>Your advisor can set these up for you based on the allocation above.</div>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: '10px' }}>
                                                {['Mutual funds (SIP / lumpsum)', 'Specialised Investment Funds (SIF)', 'Fixed deposits and bonds', 'Gold and silver'].map(name => (
                                                    <div key={name} style={{ background: '#f1f7ee', borderRadius: '8px', padding: '8px 12px', fontSize: '0.8rem', fontWeight: '700', color: '#1e293b', whiteSpace: 'nowrap' }}>
                                                        {name}
                                                    </div>
                                                ))}
                                                <div style={{ background: '#f1f7ee', borderRadius: '8px', padding: '10px 12px', flex: '1 1 260px' }}>
                                                    <div style={{ fontSize: '0.8rem', fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>Other products</div>
                                                    <div style={{ fontSize: '0.74rem', color: '#475569', lineHeight: '1.5' }}>NPS for retirement tax benefits, PMS and AIF for larger portfolios, annuity plans for post-retirement income.</div>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginTop: '14px', paddingTop: '12px', borderTop: '1px solid #e2e8f0' }}>
                                                <div style={{ fontSize: '0.78rem', color: '#475569', maxWidth: '420px' }}>
                                                    Not sure which products fit? Speak to your advisor to pick funds and start the ₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo SIP.
                                                </div>
                                                {/* <button type="button" style={{ background: '#3f6b2a', color: '#fff', border: 'none', fontSize: '0.85rem', fontWeight: '700', padding: '9px 18px', borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap' }}>Connect with my advisor</button> */}
                                            </div>
                                            <div style={{ fontSize: '0.68rem', color: '#64748b', marginTop: '8px' }}>
                                                Investments are subject to market risk. Product availability and minimum amounts vary; your advisor will confirm suitability.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Retirement Corpus & Income Allocation Section */}
                    <div className={`${styles.goalDetailsSection} pdf-atomic`}>
                        <h3 className={styles.investmentHeading}>Retirement Corpus &amp; Income Allocation</h3>
                        <div className={styles.corpusAnalysisDiv}>
                            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, borderRadius: '16px', overflow: 'hidden', border: '1px solid #e5e7eb', backgroundColor: '#ffffff' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e5e7eb' }}>
                                        <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em' }}>PARTICULARS</th>
                                        <th style={{ padding: '10px 16px', textAlign: 'center', fontSize: '11px', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', width: '120px' }}>%</th>
                                        <th style={{ padding: '10px 16px', textAlign: 'right', fontSize: '11px', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', width: '180px' }}>AMOUNT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#374151' }}>Monthly Income Needed on Retirement</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#6b7280', textAlign: 'center' }}>—</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#111827', textAlign: 'right' }}>
                                            ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementExpanceRYMonthly))}
                                        </td>
                                    </tr>
                                    <tr style={{ backgroundColor: '#FFE082', borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '700', color: '#111827' }}>Retirement Corpus Needed</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '700', color: '#111827', textAlign: 'center' }}>—</td>
                                        <td style={{ padding: '12px 16px', fontSize: '14px', fontWeight: '800', color: '#111827', textAlign: 'right' }}>
                                            ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementCorpusRY))}
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid #f3f4f6', backgroundColor: '#f8f9fa' }}>
                                        <td colSpan={3} style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '800', color: '#111827', textAlign: 'center', letterSpacing: '0.01em' }}>
                                            Broader-Level Allocation of Retirement Corpus
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '12px 16px 12px 32px', fontSize: '13px', fontStyle: 'italic', fontWeight: '400', color: '#4b5563' }}>To Debt MF SWP</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '400', color: '#4b5563', textAlign: 'center' }}>50%</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#111827', textAlign: 'right' }}>
                                            ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementCorpusRY) * 0.5)}
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '12px 16px 12px 32px', fontSize: '13px', fontStyle: 'italic', fontWeight: '400', color: '#4b5563' }}>To Guaranteed Lifetime Income Solutions</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '400', color: '#4b5563', textAlign: 'center' }}>25%</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#111827', textAlign: 'right' }}>
                                            ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementCorpusRY) * 0.25)}
                                        </td>
                                    </tr>
                                    <tr style={{ backgroundColor: 'transparent' }}>
                                        <td style={{ padding: '12px 16px 12px 32px', fontSize: '13px', fontStyle: 'italic', fontWeight: '400', color: '#4b5563' }}>To Fixed Income Bearing Instruments</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '400', color: '#4b5563', textAlign: 'center' }}>25%</td>
                                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#111827', textAlign: 'right' }}>
                                            ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementCorpusRY) * 0.25)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>



                    <div className={`${styles.analysis} pdf-page-two`}>
                        {/* <div className={styles.retirementAnalysisCard}>
                        <h3 className={styles.retirementTitle}>Retirement Analysis</h3>
                        <p className={styles.retirementSubText}>
                            {checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement)} Years to Retirement • {checkForNullOrNaN(userData.planDetails.retirementYears)} Years in Retirement
                        </p>
                        <div className={styles.retirementTimelineWrap}>
                            <div className={styles.retirementTimelineBase}></div>
                            <div
                                className={styles.retirementTimelineProgress}
                                style={{ width: `${Math.min(100, Math.max(0, checkForNullOrNaN(userData.planDetails.goalAchievement.percentage)))}%` }}
                            ></div>

                            <div className={`${styles.timelineDot} ${styles.timelineDotPresent}`}></div>
                            <div className={`${styles.timelineDot} ${styles.timelineDotRetirement}`}></div>
                            <div className={`${styles.timelineDot} ${styles.timelineDotTarget}`}></div>

                            <div
                                className={styles.goalBadge}
                                style={{
                                    left: checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) < 15 ? '14px' : (checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) > 85 ? 'auto' : `${Math.min(100, Math.max(0, checkForNullOrNaN(userData.planDetails.goalAchievement.percentage)))}%`),
                                    right: checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) > 85 ? '14px' : 'auto',
                                    transform: (checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) < 15 || checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) > 85) ? 'translateX(0)' : 'translateX(-50%)'
                                }}
                            >
                                Goal Achieved <span>{checkForNullOrNaN(userData.planDetails.goalAchievement.percentage).toFixed(0)}%</span> ({formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.goalAchievement.value))})
                            </div>

                            <div className={`${styles.timelineInfo} ${styles.timelineInfoPresent}`}>
                                <div>{new Date().getFullYear()}</div>
                                <span>Present</span>
                            </div>
                            <div className={`${styles.timelineInfo} ${styles.timelineInfoRetirement}`}>
                                <div>{new Date().getFullYear() - checkForNullOrNaN(userData.clientsDetails.age) + checkForNullOrNaN(userData.clientsDetails.year_of_retirement)}</div>
                                <span>Retirement Year</span>
                            </div>
                            <div className={`${styles.timelineInfo} ${styles.timelineInfoTarget}`}>
                                <div>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</div>
                                <span>Target Corpus</span>
                            </div>
                        </div>
                    </div> */}

                        {/* <div className={styles.currentStatusSection}>
                        <h3 className={styles.currentStatusTitle}>Current Financial Status</h3>
                        <div className={styles.currentStatusGrid}>
                            <div className={styles.currentStatusCard}>
                                <div className={styles.currentStatusLabel}>Current Investments</div>
                                <div className={styles.currentStatusValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.totalInvestments))}</div>
                                <div className={styles.currentStatusSplit}>
                                    <div><span>Retirement</span><b>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.RetirementInvestments))}</b></div>
                                    <div><span>Non Retirement</span><b>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))}</b></div>
                                </div>
                            </div>
                            <div className={styles.currentStatusCard}>
                                <div className={styles.currentStatusLabel}>Current Monthly SIP</div>
                                <div className={styles.currentStatusValue}>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.TotalContributions))}</div>
                                <div className={styles.currentStatusSplit}>
                                    <div><span>Retirement</span><b>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.RetirementContributions))}</b></div>
                                    <div><span>Non Retirement</span><b>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))}</b></div>
                                </div>
                            </div>
                            <div className={`${styles.currentStatusCard} ${styles.currentStatusTargetCard}`}>
                                <div className={styles.currentStatusLabel}>Target Corpus Needed</div>
                                <div className={styles.currentStatusValue}>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</div>
                                <div className={styles.currentStatusFootText}>Required to live post-retirement</div>
                            </div>
                        </div>
                    </div> */}

                        {/* doughnutDiv */}
                        {/* {userData?.investmentDetails?.goals?.length > 0 ? (
                        // --- IF GOALS EXIST (Your existing HTML) ---
                        <div className={styles.doughnutDiv}>
                            <div className={styles.doughnutTop}>
                                <div className={styles.doughnut}>
                                    <DoughnutChart
                                        corpus={formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails?.retirementCorpusRY))}
                                        data={[
                                            parseFloat(checkForNullOrNaN(userData.planDetails?.graph?.investment?.percentage).toFixed(2)),
                                            parseFloat(checkForNullOrNaN(userData.planDetails?.graph?.retirementContributions?.percentage).toFixed(2)),
                                            parseFloat(checkForNullOrNaN(userData.planDetails?.graph?.shortage?.percentage).toFixed(2))
                                        ]}
                                    />
                                </div>
                                <div className={styles.doughnutLegend}>
                                    <ul>
                                        <li>
                                            <div className={styles.labelPart}>
                                                <span className='fw-bold'>Retirement Investment Value at Retirement</span>
                                                <span>{`( ${checkForNullOrNaN(userData.planDetails?.totalAllRetirement?.percentage?.retirement).toFixed(2)}% )`}</span>
                                            </div>
                                            <div className={styles.valuePart}>
                                                ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails?.totalAllRetirement?.retirement))}
                                            </div>
                                        </li>
                                        <li>
                                            <div className={styles.labelPart}>
                                                <span className='fw-bold'>Retirement Monthly Contribution Value at Retirement</span>
                                                <span>{`( ${checkForNullOrNaN(userData.planDetails?.totalAllRetirement?.percentage?.retirementMonthly).toFixed(2)}% )`}</span>
                                            </div>
                                            <div className={styles.valuePart}>
                                                ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails?.totalAllRetirement?.retirementMonthly))}
                                            </div>
                                        </li>
                                        <li>
                                            <div className={styles.labelPart}>
                                                <span className='fw-bold'>{userData.planDetails?.shortageRYType == 'surplus' ? 'Surplus' : 'Shortage'}</span>
                                                <span>{`( ${checkForNullOrNaN(userData.planDetails?.graph?.shortage?.percentage).toFixed(2)}% )`}</span>
                                            </div>
                                            <div className={styles.valuePart}>
                                                ₹ {formatNumberToIndianUnits(Math.round(checkForNullOrNaN(userData.planDetails?.graph?.shortage?.shortageAmount)))}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className={styles.doughnutBottom}>
                                {userData.planDetails?.shortageRYType == 'surplus'
                                    ? 'Congratulations! You have reached the stage of financial freedom. Your financial plan is strong and adequately supports your future requirements'
                                    : `To cover shortage start saving ₹ ${Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData?.planDetails?.additionalSavRqd?.monthly))}/m or lumpsum ₹ ${Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData?.planDetails?.additionalLumsumRqd?.value))} `
                                }
                            </div>
                        </div>
                    ) : (
                        <div className={styles.doughnutDiv}>
                            <div className={styles.doughnutTop}>
                                <div className={styles.doughnut}>
                                    <DoughnutChart
                                        corpus={formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails?.retirementCorpusRY))}
                                        data={[
                                            parseFloat(checkForNullOrNaN(userData.planDetails?.graph?.investment?.percentage).toFixed(2)),
                                            parseFloat(checkForNullOrNaN(userData.planDetails?.graph?.retirementContributions?.percentage).toFixed(2)),
                                            parseFloat(checkForNullOrNaN(userData.planDetails?.graph?.shortage?.percentage).toFixed(2))
                                        ]}
                                    />
                                </div>
                                <div className={styles.doughnutLegend}>
                                    <ul>
                                        <li>
                                            <div className={styles.labelPart}>
                                                <span className='fw-bold'>Total Investment Value at Retirement</span>
                                                <span>{`( ${checkForNullOrNaN(userData.planDetails?.totalAllRetirement?.percentage?.retirement).toFixed(2)}% )`}</span>
                                            </div>
                                            <div className={styles.valuePart}>
                                                ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails?.graph?.investment?.investmentAmount))}
                                            </div>
                                        </li>
                                        <li>
                                            <div className={styles.labelPart}>
                                                <span className='fw-bold'>Total Monthly Contribution Value at Retirement</span>
                                                <span>{`( ${checkForNullOrNaN(userData.planDetails?.totalAllRetirement?.percentage?.retirementMonthly).toFixed(2)}% )`}</span>
                                            </div>
                                            <div className={styles.valuePart}>
                                                ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails?.graph?.retirementContributions?.retirementContributionsAmount))}
                                            </div>
                                        </li>
                                        <li>
                                            <div className={styles.labelPart}>
                                                <span className='fw-bold'>{userData.planDetails?.shortageRYType == 'surplus' ? 'Surplus' : 'Shortage'}</span>
                                                <span>{`( ${checkForNullOrNaN(userData.planDetails?.graph?.shortage?.percentage).toFixed(2)}% )`}</span>
                                            </div>
                                            <div className={styles.valuePart}>
                                                ₹ {formatNumberToIndianUnits(Math.round(checkForNullOrNaN(userData.planDetails?.graph?.shortage?.shortageAmount)))}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                    {/* Retirement Analysis Card and other sections commented out by user */}
                    </div>

                    {/* Action Plan */}
                    <div className={`${styles.actionPlan} pdf-page-three`}>
                        <h3 className={styles.investmentHeading}>Action Plan</h3>

                        {userData.planDetails.shortageRYType === 'surplus' ? (
                            // ── SURPLUS CASE ──
                            <div style={{
                                background: '#f0fdf4', border: '2px solid #86efac',
                                borderRadius: '16px', padding: '28px 32px', textAlign: 'center'
                            }}>
                                <div style={{ fontSize: '2rem', marginBottom: '10px' }}>🎉</div>
                                <div style={{ fontSize: '1.2rem', fontWeight: '800', color: '#15803d', marginBottom: '8px' }}>
                                    No Additional SIP Required
                                </div>
                                <div style={{ fontSize: '0.92rem', color: '#166534', lineHeight: '1.7' }}>
                                    Your retirement corpus target of <b>{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</b> is fully covered.<br />
                                    Projected corpus of <b>₹{formatNumberToIndianUnits(
                                        checkForNullOrNaN(userData.planDetails.totalAllRetirement?.retirement)
                                        + checkForNullOrNaN(userData.planDetails.totalAllRetirement?.retirementMonthly)
                                        + liquidSurplus
                                        + checkForNullOrNaN(unallocatedCapitalReceiptsFV)
                                    )}</b> exceeds the target with a surplus of <b>₹{formatNumberToIndianUnits(
                                        correctedSurplus
                                    )}</b>.<br />
                                    Your financial plan is strong and adequately supports your future requirements.
                                </div>
                            </div>
                        ) : (
                            // ── SHORTAGE CASE ──
                            <>
                                <p className={styles.actionPlanSubtitle}>
                                    Choose one of the two paths below to rebalance your portfolio and reach your ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))} target.
                                </p>
                                <div className={styles.actionPlanGrid}>
                                    {/* Plan A */}
                                    <div className={`${styles.apCard} ${styles.apCardPlanA}`}>
                                        <div className={styles.apCardHeader}>📈 PLAN A — SIP (RECOMMENDED)</div>
                                        <table className={styles.apTable}>
                                            <thead>
                                                <tr><th style={{ borderTopLeftRadius: "0rem" }}>PURPOSE</th><th style={{ textAlign: 'right', borderTopRightRadius: "0rem" }}>AMOUNT</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '8px' }}>account_balance</span> Retirement SIP</td>
                                                    <td style={{ textAlign: 'right' }}>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</td>
                                                </tr>
                                                <tr className={styles.apTableTotalRow}>
                                                    <td style={{ borderBottomLeftRadius: "0rem" }}>Total Additional SIP / Month</td>
                                                    <td style={{ textAlign: 'right', borderBottomRightRadius: "0rem" }}>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {/* <div className={styles.apFooterNote}>SIP amounts redirect to Retirement Corpus as each goal is achieved.</div> */}
                                    </div>
                                    {/* Plan B */}
                                    <div className={`${styles.apCard} ${styles.apCardPlanB}`}>
                                        <div className={styles.apCardHeader}>💰 PLAN B — LUMPSUM</div>
                                        <table className={styles.apTable}>
                                            <thead>
                                                <tr><th style={{ borderTopLeftRadius: "0rem" }}>GOAL</th><th style={{ textAlign: 'right', borderTopRightRadius: "0rem" }}>LUMPSUM NOW</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '8px' }}>account_balance</span> Retirement Gap</td>
                                                    <td style={{ textAlign: 'right' }}>{formatNumberToIndianUnits(correctedLumpsum)}</td>
                                                </tr>
                                                <tr className={styles.apTableTotalRow}>
                                                    <td style={{ borderBottomLeftRadius: "0rem" }}>Total Lumpsum Required</td>
                                                    <td style={{ textAlign: 'right', borderBottomRightRadius: "0rem" }}>{formatNumberToIndianUnits(correctedLumpsum)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {/* <div className={styles.apFooterNote}>Invest lumpsum today to fully close the retirement</div> */}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Plan at a Glance Section */}
                    <div className={styles.glanceDiv}>
                        <h3 className={styles.investmentHeading}>Plan at a Glance</h3>
                        <div className={styles.glanceMainCard}>
                            <div className={styles.glanceCardsGrid}>
                                {/* Card 1: Retirement */}
                                <div className={`${styles.glanceCard} ${styles.glanceRetirement}`}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>
                                            {userData.planDetails.shortageRYType === 'surplus' ? '✅' : '⚠️'}
                                        </span> RETIREMENT
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {userData.planDetails.shortageRYType === 'surplus' ? 'SURPLUS' : 'SHORTAGE'}
                                    </div>
                                    {/* <div className={styles.glanceCardSub}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? `+${formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.shortageRY))} ABOVE TARGET ✓`
                                            : `-${formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.shortageRY))} BELOW TARGET`
                                        }
                                    </div> */}
                                </div>

                                {/* Card 2: Goals */}
                                <div className={`${styles.glanceCard} ${styles.glanceGoals}`}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>✅</span> GOALS
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {fundedGoalsWithRetirement}/{totalGoalsWithRetirement} FUNDED
                                    </div>
                                    {/* <div className={styles.glanceCardSub}>
                                        {shortGoalsWithRetirement === 0 ? "ALL GOALS ON TRACK" : `${shortGoalsWithRetirement} GOALS NEED ATTENTION`}
                                    </div> */}
                                </div>

                                {/* Card 3: Insurance */}
                                {(() => {
                                    const recommendedTerm = checkForNullOrNaN(userData?.planDetails?.insurance?.li_si);
                                    const recommendedHealth = checkForNullOrNaN(userData?.planDetails?.insurance?.hi_si);
                                    const policies = userData?.investmentDetails?.insurance_coverage || [];
                                    const totalTermCoverage = policies.filter(p => p.type === 'Term Insurance').reduce((s, p) => s + checkForNullOrNaN(p.coverage), 0);
                                    const totalHealthCoverage = policies.filter(p => p.type === 'Health Insurance').reduce((s, p) => s + checkForNullOrNaN(p.coverage), 0);
                                    const termGap = getTermInsuranceRows().reduce((sum, r) => sum + r.gap, 0);
                                    const healthGap = Math.max(0, recommendedHealth - totalHealthCoverage);
                                    const hasInsuranceGap = termGap > 0 || healthGap > 0;

                                    return (
                                        <div className={`${styles.glanceCard} ${styles.glanceInsurance}`}>
                                            <div className={styles.glanceCardHeader}>
                                                <span className={styles.glanceCardIcon}>
                                                    {hasInsuranceGap ? '⚠️' : '✅'}
                                                </span> INSURANCE
                                            </div>
                                            {/* <div className={styles.glanceCardValue}>
                                                {hasInsuranceGap ? 'SHORTFALL' : 'COVERED'}
                                            </div> */}
                                            <div className={styles.glanceCardSub} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
                                                <span style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
                                                    <span style={{ fontWeight: "700" }}>TERM</span>
                                                    <span style={{ color: termGap > 0 ? '#dc2626' : '#16a34a', fontWeight: 'bold' }}>{termGap > 0 ? '❌' : '✓'}</span>
                                                </span>
                                                <span style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
                                                    <span style={{ fontWeight: "700" }}>HEALTH</span>
                                                    <span style={{ color: healthGap > 0 ? '#dc2626' : '#16a34a', fontWeight: 'bold' }}>{healthGap > 0 ? '❌' : '✓'}</span>
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {/* Card 4: Action Needed */}
                                <div className={`${styles.glanceCard} ${styles.glanceAction}`}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>📌</span> ACTION NEEDED
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>NOT REQUIRED ✓</span>
                                            : `₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo`
                                        }
                                    </div>
                                    {/* <div className={styles.glanceCardSub}>
                                        {userData.planDetails.shortageRYType === 'surplus' ? 'CORPUS TARGET ALREADY MET' : 'RETIREMENT SIP ONLY'}
                                    </div> */}
                                </div>
                                {/* Card 5: Lumpsum */}
                                <div className={`${styles.glanceCard} ${styles.glanceAction}`}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>💰</span> LUMPSUM OPTION
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>NOT REQUIRED ✓</span>
                                            : formatNumberToIndianUnits(correctedLumpsum)
                                        }
                                    </div>
                                    {/* <div className={styles.glanceCardSub}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? 'CORPUS TARGET ALREADY MET'
                                            : 'ONE-TIME INVESTMENT CLOSE TO GAP'
                                        }
                                    </div> */}
                                </div>

                            </div>

                            {/* Recommended Allocation Section */}
                            {/* <div className={styles.allocationSection}>
                                <div className={styles.allocationTitle}>
                                    RECOMMENDED ALLOCATION
                                    <span className={styles.allocationStrategy}>{strategyLabel}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                                    <div className={styles.allocationBars} style={{ width: '100%' }}>
                                        {[
                                            { label: 'Equity', pct: equityPct, labelColor: '#1565C0', barClass: styles.progressBlue },
                                            { label: 'Debt', pct: debtPct, labelColor: '#2E7D32', barClass: styles.progressGreen },
                                            { label: 'Cash', pct: cashPct, labelColor: '#E65100', barClass: styles.progressOrange },
                                            { label: 'Gold', pct: goldPct, labelColor: '#b45309', barBg: '#d97706' },
                                            { label: 'Silver', pct: silverPct, labelColor: '#6b7280', barBg: '#94a3b8' },
                                            { label: 'ST Debt', pct: stDebtPct, labelColor: '#6b7280', barBg: '#9ca3af' },
                                        ]
                                            .filter(b => b.pct > 0)
                                            .sort((a, b) => b.pct - a.pct)
                                            .map(b => (
                                                <div key={b.label} className={styles.allocationBarItem}>
                                                    <span style={{ color: b.labelColor, width: '60px', fontSize: '0.82rem', fontWeight: '600', flexShrink: 0 }}>{b.label}</span>
                                                    <div className={styles.progressBarWrapper} style={{ flex: 1 }}>
                                                        <div
                                                            className={`${styles.progressBar} ${b.barClass || ''}`}
                                                            style={{ width: `${b.pct}%`, ...(b.barBg ? { background: b.barBg } : {}) }}
                                                        ></div>
                                                    </div>
                                                    <span style={{ color: b.labelColor, width: '40px', textAlign: 'right', fontSize: '0.82rem', fontWeight: '700' }}>{b.pct}%</span>
                                                </div>
                                            ))}
                                    </div>
                                    <div className={styles.allocationCallout}>
                                        {userData.planDetails.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a' }}>✓ No additional investment needed — corpus target already met</span>
                                            : <>Invest <b>₹{Intl.NumberFormat('en-IN').format(Math.round(checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly) + (userData?.investmentDetails?.goals?.length > 0 ? Object.values(goalsData || {}).reduce((acc, curr) => acc + curr.additionalSavings, 0) : 0)))}/mo</b> across this mix</>
                                        }
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>


                    {/* Insurance & Loans Section */}
                    {(() => {
                        const recommendedTerm = checkForNullOrNaN(userData?.planDetails?.insurance?.li_si);
                        const recommendedHealth = checkForNullOrNaN(userData?.planDetails?.insurance?.hi_si);
                        const policies = userData.investmentDetails?.insurance_coverage || [];
                        const loans = userData.investmentDetails?.liabilities_loans || [];
                        const totalTermCoverage = policies.filter(p => p.type === 'Term Insurance').reduce((s, p) => s + checkForNullOrNaN(p.coverage), 0);
                        const totalHealthCoverage = policies.filter(p => p.type === 'Health Insurance').reduce((s, p) => s + checkForNullOrNaN(p.coverage), 0);
                        const termGap = getTermInsuranceRows().reduce((sum, r) => sum + r.gap, 0);
                        const healthGap = Math.max(0, recommendedHealth - totalHealthCoverage);
                        const totalPremium = policies.reduce((s, p) => s + checkForNullOrNaN(p.premium), 0);
                        const totalOutstanding = loans.reduce((s, l) => s + checkForNullOrNaN(l.outstanding), 0);
                        const totalLoanAmt = loans.reduce((s, l) => s + checkForNullOrNaN(l.total), 0);
                        const totalEmi = loans.reduce((s, l) => s + checkForNullOrNaN(l.emi), 0);
                        const termRows = getTermInsuranceRows();

                        return (
                            <div style={{ margin: '2rem 2rem' }}>

                                {/* Insurance Coverage & Gap Analysis */}
                                <div style={{ marginBottom: '2rem' }}>
                                    <h3 className={styles.investmentHeading}>Insurance Coverage &amp; Gap Analysis</h3>

                                    {/* Gap Summary Table */}
                                    <table className={styles.insTable}>
                                        <thead>
                                            <tr>
                                                {['TYPE', 'REQUIRED', 'EXISTING', 'GAP', 'STATUS'].map(h => (
                                                    <th key={h}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {termRows.map(row => (
                                                <tr key={`term-${row.key}`}>
                                                    <td>
                                                        <div className={styles.insTypeLabel}>{row.label} {row.isHLV ? '(HUMAN LIFE VALUE Method)' : '(NEEDS-BASED Method)'}</div>
                                                        <div className={styles.insTypeSub}>
                                                            {row.isHLV
                                                                ? '( Annual Income x Years to Retirement - Current Assets + Loans )'
                                                                : '( PV of survivor expenses + loans + PV of goals - Current Assets )'}
                                                        </div>
                                                    </td>
                                                    <td className={styles.insReqValue}>{formatInsuranceValue(row.required)}</td>
                                                    <td className={styles.insExistValue}>{row.existing > 0 ? formatInsuranceValue(row.existing) : 'Not added'}</td>
                                                    <td className={row.gap > 0 ? styles.insGapShort : styles.insGapCovered}>
                                                        {row.gap > 0 ? formatInsuranceValue(row.gap) : '✓ Covered'}
                                                    </td>
                                                    <td>
                                                        <span className={`${styles.insStatusPill} ${row.gap > 0 ? styles.insStatusPillShort : styles.insStatusPillCovered}`}>
                                                            {row.gap > 0 ? 'Shortfall' : 'Covered'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td>
                                                    <div className={styles.insTypeLabel}>Health Insurance</div>
                                                    <div className={styles.insTypeSub}>( 2x Annual Income )</div>
                                                </td>
                                                <td className={styles.insReqValue}>{formatInsuranceValue(recommendedHealth)}</td>
                                                <td className={styles.insExistValue}>{totalHealthCoverage > 0 ? formatInsuranceValue(totalHealthCoverage) : 'Not added'}</td>
                                                <td className={healthGap > 0 ? styles.insGapShort : styles.insGapCovered}>
                                                    {healthGap > 0 ? formatInsuranceValue(healthGap) : '✓ Covered'}
                                                </td>
                                                <td>
                                                    <span className={`${styles.insStatusPill} ${healthGap > 0 ? styles.insStatusPillShort : styles.insStatusPillCovered}`}>
                                                        {healthGap > 0 ? 'Shortfall' : 'Covered'}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* Policy Detail Table */}
                                    {policies.length > 0 && (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                                            <thead>
                                                <tr style={{ background: '#f8fafc' }}>
                                                    {['POLICY', 'COVERAGE', 'PREMIUM/YR', 'RENEWAL', 'DETAILS'].map(h => (
                                                        <th key={h} style={{ padding: '10px 14px', fontSize: '0.72rem', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: h === 'POLICY' ? 'left' : 'right', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
                                                            {h}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {policies.map((policy, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9', background: '#fff' }}>
                                                        <td style={{ padding: '12px 14px', fontSize: '0.9rem', color: '#1e293b', fontWeight: '600' }}>
                                                            {policy.type}
                                                            {policy.type === 'Term Insurance' && (policy.calcMethod === 'HLV' ? ' (HUMAN LIFE VALUE Method)' : ' (NEEDS-BASED Method)')}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#1e293b', fontWeight: '700' }}>
                                                            {formatInsuranceValue(checkForNullOrNaN(policy.coverage))}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#475569' }}>
                                                            Rs.{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(policy.premium))}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#475569' }}>
                                                            {policy.renewalDate || '—'}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#475569' }}>
                                                            {policy.type !== 'Term Insurance'
                                                                ? '—'
                                                                : policy.calcMethod === 'HLV'
                                                                    ? `HLV`
                                                                    : (policy.dependentAge || policy.dependentLifeExpectancy || policy.dependentExpenses)
                                                                        ? `Age ${policy.dependentAge || '—'} LE ${policy.dependentLifeExpectancy || '—'}${policy.dependentExpenses ? ` / Exp ₹${Intl.NumberFormat('en-IN').format(policy.dependentExpenses)}` : ''}`
                                                                        : '—'
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                                {/* Total Premium Row */}
                                                <tr style={{ background: '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                                                    <td style={{ padding: '12px 14px', fontWeight: '800', fontSize: '0.95rem', color: '#0f172a' }}>
                                                        Total Premium
                                                    </td>
                                                    <td style={{ padding: '12px 14px' }}></td>
                                                    <td style={{ padding: '12px 14px', textAlign: 'right', fontWeight: '800', fontSize: '0.95rem', color: '#0f172a' }}>
                                                        Rs.{Intl.NumberFormat('en-IN').format(totalPremium)}
                                                    </td>
                                                    <td colSpan="2"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                {/* Liabilities & Loans */}
                                {loans.length > 0 && (
                                    <div>
                                        <h3 className={styles.investmentHeading}>Liabilities &amp; Loans</h3>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                                            <thead>
                                                <tr style={{ background: '#f8fafc' }}>
                                                    {['LOAN TYPE', 'TOTAL LOAN', 'OUTSTANDING LOAN', 'REMAINING', 'MONTHLY EMI'].map(h => (
                                                        <th key={h} style={{ padding: '10px 14px', fontSize: '0.72rem', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: h === 'LOAN TYPE' ? 'left' : 'right', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
                                                            {h}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loans.map((loan, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9', background: '#fff' }}>
                                                        <td style={{ padding: '12px 14px', fontSize: '0.9rem', color: '#1e293b', fontWeight: '600' }}>
                                                            {loan.type}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#475569' }}>
                                                            {formatInsuranceValue(checkForNullOrNaN(loan.total))}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#475569' }}>
                                                            {formatInsuranceValue(checkForNullOrNaN(loan.outstanding))}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#475569' }}>
                                                            {loan.remaining ? `${loan.remaining} yrs` : '—'}
                                                        </td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'right', fontSize: '0.9rem', color: '#1e293b', fontWeight: '700' }}>
                                                            ₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(loan.emi))}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {/* Total Row */}
                                                <tr style={{ background: '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                                                    <td style={{ padding: '12px 14px', fontWeight: '800', fontSize: '0.95rem', color: '#0f172a' }}>Total</td>
                                                    <td style={{ padding: '12px 14px', textAlign: 'right', fontWeight: '800', fontSize: '0.95rem', color: '#0f172a' }}>
                                                        {formatInsuranceValue(totalLoanAmt)}
                                                    </td>
                                                    <td style={{ padding: '12px 14px', textAlign: 'right', fontWeight: '800', fontSize: '0.95rem', color: '#0f172a' }}>
                                                        {formatInsuranceValue(totalOutstanding)}
                                                    </td>
                                                    <td style={{ padding: '12px 14px' }}></td>
                                                    <td style={{ padding: '12px 14px', textAlign: 'right', fontWeight: '800', fontSize: '0.95rem', color: '#0f172a' }}>
                                                        ₹{Intl.NumberFormat('en-IN').format(totalEmi)}/mo
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        );
                    })()}

                    {/* Goal Cashflow Statement */}
                    {(userData.investmentDetails.goals?.length > 0 &&
                        <div className={`${styles.cashFlow} ${styles.retirementCashFlowSection}`}>
                            <div className={styles.analysisHead}>
                                <div className={styles.redAccent}></div>
                                <span><b>Goal Cashflow Statement</b></span>
                            </div>
                            <p style={{ fontSize: '0.85rem', color: '#64748b', margin: '-0.5rem 0 1rem 0.5rem', fontStyle: 'italic' }}>
                                Pre-retirement period — tracks corpus growth, savings, goal withdrawals and capital receipts up to last goal year.
                            </p>
                            {/* cash-flow Table */}
                            <div className={styles.tableWrapper}>
                                <table className={styles.retirementCashFlowTable}>
                                    <thead>
                                        <tr>
                                            <th style={{ borderTopLeftRadius: "0rem" }}>Age / Year</th>
                                            <th>Opening Balance</th>
                                            <th>Returns</th>
                                            <th>Current Savings</th>
                                            <th className={styles.greenHeader}>Additional Savings</th>
                                            <th>Goal Withdrawal</th>
                                            <th>Net Capital Receipts / Goal Requirement</th>
                                            {/* <th>Net Goal Requirement</th> */}
                                            <th style={{ borderTopRightRadius: "0rem" }}>Year End Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {nonRetirementRows?.map((row, index) => {
                                            const isWithdrawal = (row[6] ?? 0) > 0;
                                            return (
                                                <tr key={index} className={isWithdrawal ? styles.withdrawalRow : ""}>
                                                    <td className={styles.ageYearCell} style={{ borderBottomLeftRadius: "0rem" }}>
                                                        {row[0]} / {row[1]}
                                                    </td>
                                                    <td>{formatNumberToIndianUnits(row[2] ?? 0)}</td>
                                                    <td>{formatNumberToIndianUnits(row[3] ?? 0)}</td>
                                                    <td>{formatNumberToIndianUnits(row[4] ?? 0)}</td>
                                                    <td className={(row[5] ?? 0) > 0 ? styles.textGreen : ""}>
                                                        {(row[5] ?? 0) > 0 ? `+ ${formatNumberToIndianUnits(row[5])}` : formatNumberToIndianUnits(row[5] ?? 0)}
                                                    </td>
                                                    <td className={(row[6] ?? 0) > 0 ? styles.textRed : ""}>
                                                        {(row[6] ?? 0) > 0 ? `- ${formatNumberToIndianUnits(row[6])}` : formatNumberToIndianUnits(row[6] ?? 0)}
                                                    </td>
                                                    <td className={(row[7] ?? 0) > 0 ? styles.textPurple : ""}>
                                                        {formatNumberToIndianUnits(row[7] ?? 0)}
                                                    </td>
                                                    {/* <td className={(row[8] ?? 0) > 0 ? styles.textRed : ""}>
                                                        {(row[8] ?? 0) > 0 ? `- ${formatNumberToIndianUnits(row[8])}` : formatNumberToIndianUnits(row[8] ?? 0)}
                                                    </td> */}
                                                    <td className={(row[9] ?? 0) < 0 ? styles.textRed : styles.textBold} style={{ borderBottomRightRadius: "0rem" }}>
                                                        {formatNumberToIndianUnits(row[9] ?? 0)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className={styles.apPolicy}>
                                {userData.planDetails.shortageRYType === 'surplus'
                                    ? <p>Your non-retirement savings of <b>{formatNumberToIndianUnits(userData.planDetails.NonRetirementContributions * 12)}</b>/yr are well on track to meet all goals before retirement. With a corpus surplus of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(Object.keys(goalsData).length > 0 ? userData?.planDetails?.unallocatedAssetsSurplus : userData.planDetails.shortageRY))}</b>, no additional investments are required. ✓</p>
                                    : <p>Your non-retirement savings of <b>{formatNumberToIndianUnits(userData.planDetails.NonRetirementContributions * 12)}</b>/yr will be available to meet other goals before retirement. You can adjust your additional savings for retirement by that amount after meeting all goals.</p>
                                }
                            </div> */}
                        </div>
                    )}


                    {/* Cash Flow */}
                    <div className={`${styles.cashFlow} ${styles.retirementCashFlowSection}`}>
                        <div className={styles.analysisHead}>
                            <div className={styles.redAccent}></div>
                            <span><b>Retirement Cash Flow Statement</b></span>
                        </div>

                        <p style={{ fontSize: '0.85rem', color: '#64748b', margin: '-0.5rem 0 1rem 0.5rem', fontStyle: 'italic' }}>
                            {userData.planDetails.shortageRYType === 'surplus'
                                ? <>From retirement year onwards — corpus exceeds target with a <span style={{ color: '#16a34a', fontWeight: '700' }}>surplus of ₹{formatNumberToIndianUnits(correctedSurplus)}</span>. Tracks comfortable drawdown against inflation-adjusted expenses through life expectancy. ✓</>
                                : 'From retirement year onwards — tracks drawdown of corpus against inflation-adjusted expenses through life expectancy.'
                            }
                        </p>
                        {/* cash-flow Table */}
                        <div className={styles.tableWrapper}>
                            <table className={styles.retirementCashFlowTable}>
                                <thead>
                                    <tr>
                                        <th style={{ borderTopLeftRadius: "0rem" }}>Age / Year</th>
                                        <th>Begin Assets</th>
                                        <th>Annual Return</th>
                                        <th>Annual Savings</th>
                                        <th className={styles.greenHeader}>Additional Savings</th>
                                        <th>Capital Receipts/Surplus</th>
                                        <th>Expense Withdrawals</th>
                                        <th>Goal Withdrawal</th>
                                        <th style={{ borderTopRightRadius: "0rem" }}>Year End Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows?.map((row, index) => {
                                        const age = parseInt(row[0].split(' / ')[0]);
                                        const isRetirementYear = age === userData.clientsDetails.year_of_retirement;
                                        const isPostRetirement = age >= userData.clientsDetails.year_of_retirement;

                                        return (
                                            <tr key={index} className={isPostRetirement ? styles.retirementYearRow : ""}>
                                                <td className={styles.ageYearCell} style={{ borderBottomLeftRadius: "0rem" }}>
                                                    {row[0]} {isRetirementYear && "★"}
                                                </td>
                                                <td>{formatNumberToIndianUnits(row[1] ?? 0)}</td>
                                                <td>{formatNumberToIndianUnits(row[2] ?? 0)}</td>
                                                <td>{formatNumberToIndianUnits(row[3] ?? 0)}</td>
                                                <td className={(row[4] ?? 0) > 0 ? styles.textGreen : ""}>
                                                    {(row[4] ?? 0) > 0 ? `+ ${formatNumberToIndianUnits(row[4])}` : formatNumberToIndianUnits(row[4] ?? 0)}
                                                </td>
                                                <td className={(row[5] ?? 0) > 0 ? styles.textPurple : ""}>
                                                    {formatNumberToIndianUnits(row[5] ?? 0)}
                                                </td>
                                                <td>{formatNumberToIndianUnits(row[6] ?? 0)}</td>
                                                <td className={(row[7] ?? 0) > 0 ? styles.textRed : ""}>
                                                    {(row[7] ?? 0) > 0 ? `- ${formatNumberToIndianUnits(row[7])}` : formatNumberToIndianUnits(row[7] ?? 0)}
                                                </td>
                                                <td className={(row[8] ?? 0) < 0 ? styles.textRed : styles.textBold} style={{ borderBottomRightRadius: "0rem" }}>
                                                    {formatNumberToIndianUnits(row[8] ?? 0)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Table Legend */}
                        <div className={styles.tableLegend}>
                            ★ = Retirement year | Yellow rows = post-retirement | Purple = capital receipt inflows | Red = withdrawals | Green = Additional Savings (new SIP for goals + retirement)
                        </div>

                        {/* Footer Info */}
                        <div className={styles.tableFooterInfo}>
                            <p>Bajaj Capital Pvt. Ltd. | SEBI Reg. No. INA100001398 | Prepared by: Advisor / RETIREMENT SWAT TEAM | Prepared on: {formatDate(firstVersionDate || userData?.clientsDetails?.created_at)}</p>
                            <p className={styles.footerDisclaimer}>
                                Mutual Fund investments are subject to market risks. Read all scheme related documents carefully. This plan is for illustration purposes only.
                            </p>
                        </div>
                    </div>


                    {/* Disclaimer */}
                    <div className={styles.disclaimer}>
                        <div className={styles.discHead}><span>Disclaimer</span></div>
                        <p>
                            In the preparation of this Retirement Plan (&quot;Plan&quot;) and its content including images, text, files, etc., Bajaj Capital Private Limited (BCIAPL) has used information available in public domain including inputs submitted by the client. This plan is client-specific in nature and is subject to customization doing risk profiling of each client.
                        </p>
                        <p>

                            This plan is developed in-house by BCIAPL in the capacity of a SEBI registered Investment Advisor [SEBI Reg. No. INA100001398]. Information and content related to Insurance product (s) are provided by M/s Bajaj Capital Insurance Broking Limited(&quot;BICIBL&quot;) a Group Company within the Bajaj Capital Group. BCIBL is an IRDA licensed Composite Broker bearing License No. 241, Broker Code CB 042/02.</p>
                        <p>

                            The information provided hereinabove is generic in nature, for knowledge and information purposes only. Before taking decision to take out any investment product(s) and/ or insurance policy(ies), you are requested to take appropriate guidance from an investment Advisor/ lnsurance Expert and for tax related matters from a Tax Consultant.</p>
                        <p>

                            No fees is being charged for preparation of the Plan and the user of the is under no obligation to avail implementation of the Plan from BCIAPL.
                        </p>
                        <p>
                            Mutual Funds Investments are to market risk and read the offer document before investing.
                        </p>
                        <p>
                            Retirement plan is prepared basis assumptions of inflation, expected returns from various investment options for a long term horizon and actual performance may vary from the indicated figures used in plan for illustration purposes.
                        </p>
                    </div>
                </div>
            </div> : <div><h1>LOADING...</h1></div>}
            {/* MODAL */}
            {showModal && <Modal setShowModal={setShowModal} flag={downloadFlag} loading={loading} name={userData?.clientsDetails?.client_name} />}


        </>
    )
}

export default PlanOutput